<template>
	<div>
		<el-row>
			<el-col>
				<el-form :inline='true'>
					<el-form-item label="关键字:">
						<el-input v-model="filters.keyWord" @input="(e) => (filters.keyWord = utils.validForbid(e))"
						          placeholder="项目编号/项目名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="filters.contractId" placeholder="请选择地区" filterable clearable>
							<el-option
									v-for="item in ddIdContractList"
									:key="item.id"
									:label="item.customerName"
									:value="item.id"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="filters.entyType" placeholder="项目状态" multiple clearable>
							<el-option
									v-for="item in entyTypeArr"
									:key="item.value"
									:label="item.name"
									:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="filters.excludeTestArea" placeholder="是否排除测试地区" clearable>
							<el-option
									v-for="item in textAreas"
									:key="item.value"
									:label="item.name"
									:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="filters.techExpertUserId" placeholder="筛选技术部专家" clearable>
							<el-option
									v-for="item in teachUserArr"
									:key="item.value"
									:label="item.name"
									:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="filters.ddKeyGroupRule" placeholder="分组规则筛选" clearable>
							<el-option
									v-for="item in rulersArr"
									:key="item.value"
									:label="item.name"
									:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="filters.isFirstAuditSubmit" placeholder="任务是否完成" clearable>
							<el-option
									v-for="item in auditArr"
									:key="item.value"
									:label="item.name"
									:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<div class="toolbar-container">
							<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
							<!--              <el-button type="primary" @click="pretrialToFormal" >预审转正式</el-button>-->
						</div>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<!-- 列表 -->
		<el-table
				:data="tableData"
				border
				style="width: 100%"
				v-loading="listLoading"
				ref="multipleTable"
				@current-change='currentChange'
				:highlight-current-row='true'
		>
			<el-table-column prop="id" label="项目编号" width='100' align="center" ></el-table-column>
			<!-- <el-table-column type="selection" width="45"></el-table-column> -->
			<el-table-column prop="projectNo" label="项目编号"  align="center" width="155"
			                 show-overflow-tooltip></el-table-column>
			<el-table-column prop="areaName" label="所属县（区）" width='190' align="center" show-overflow-tooltip></el-table-column>
			<el-table-column prop="projectName" label="项目名称" align="center" show-overflow-tooltip>
				<template slot-scope='scope'>
					<el-button @click="viewsEntyTemplate(scope.row)" type="text">({{'规则'}}{{scope.row.ddKeyGroupRuleType}}){{ scope.row.projectName }}{{scope.row.firstWorkFlowStageDetail&&scope.row.firstWorkFlowStageDetail.assignOpinionSummaryUserName?('('+scope.row.firstWorkFlowStageDetail.assignOpinionSummaryUserName.split('-')[0]+')'):''}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="projectName" label="相似项目" align="center" width="90" show-overflow-tooltip>
				<template slot-scope='scope'>
					<el-button @click="viewsSimilarProject(scope.row)" type="text">{{ '查看' }}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="ddIdVenueNature" label="场所类型" align="center" show-overflow-tooltip width="120">
				<template slot-scope='scope'>
					<div v-for="item in ddIdVenueNature">
						<el-tag v-if="scope.row.ddIdVenueNature === item.id"  type="success">{{ item.value }}</el-tag>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="ddIdProjectStatusName" label="项目状态" align="center" width="140" show-overflow-tooltip></el-table-column>
			<el-table-column prop="SendTime" label="审查" align="center" width="90">
				<template slot-scope='scope'>
					<el-button  v-if="scope.row.ddIdProjectStatus===45||scope.row.ddIdProjectStatus===52||scope.row.ddIdProjectStatus===46||scope.row.ddIdProjectStatus===53||scope.row.isContinueAudit"  @click="viewProjectFile(scope.row)" type="text">审查</el-button>
					<el-button  v-if="scope.row.ddIdProjectStatus===46||scope.row.ddIdProjectStatus===53"  @click="checkOpinonViewDetail(scope.row)" type="text">汇总意见</el-button>
				</template>
			</el-table-column>
<!--			<el-table-column prop="" label="初审是否完成" align="center" width="80">-->
<!--				<template slot-scope="scope">-->
<!--					<span v-if="scope.row.isFirstAuditSubmit === 0"> {{'全部'}} </span>-->
<!--					<span v-else-if="scope.row.isFirstAuditSubmit === 1">{{'未完成'}}</span>-->
<!--					<span v-else>{{''}}</span>-->
<!--				</template>-->
<!--			</el-table-column>-->
			<el-table-column prop="SendTime" label="项目阶段" align="center" width="65">
				<template slot-scope='scope'>
					<el-button @click="viewStageList(scope.row)" type="text">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="SendTime" label="终审报告" align="center" width="65">
				<template slot-scope='scope'>
					<el-button @click="viewsAuditReport(scope.row)" type="text">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="SendTime" label="答疑" align="center" width="65">
				<template slot-scope='scope'>
					<el-button @click="viewsAnswering(scope.row)" type="text">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="SendTime" label="日志" align="center" width="65">
				<template slot-scope='scope'>
					<el-button @click="viewsLog(scope.row)" type="text">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--    <FireApplicationForm :projectRegister.sync="projectRegister" @update:projectRegister="updateDialogVisibleData" :neeData="needData"/>-->
<!--	查看相似项目	-->
		<el-dialog
				title="查看相似项目"
				:visible.sync="viewsSimilarProjectDialog"
				v-model="viewsSimilarProjectDialog"
				:close-on-click-modal="false"
				width='1200px'
		>
			<el-table
					:data="viewsSimilarProjectList"
					border
					style="width: 100%"
					v-loading="listLoading"
					ref="multipleTable"
					@current-change='currentChange'
					:highlight-current-row='true'
			>
				<el-table-column type='index' label="序号" width='60' align="center" :index='indexMethod'></el-table-column>
				<!-- <el-table-column type="selection" width="45"></el-table-column> -->
				<el-table-column prop="projectNo" label="项目编号"  align="center" width="180" show-overflow-tooltip></el-table-column>
				<el-table-column prop="projectName" label="项目名称" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="projectAddress" label="项目地址" align="center" show-overflow-tooltip></el-table-column>
				
			</el-table>
		</el-dialog>
		<!--  消防审查申请表-->
		<el-dialog
				title="项目登记"
				:visible.sync="projectRegisterDialog"
				v-model="projectRegisterDialog"
				:close-on-click-modal="false"
				width='1200px'
		>
			<WordTable :isDisabled="false" :projectId="needData ? needData.id : 0"
			           :needData="needData" @closeThisDialog="closeThisDialog"></WordTable>
		</el-dialog>
		<!--  预审转正式-->
		<el-dialog
				:title="'预审转正式'"
				:visible.sync="addNewEntryDialogToForm"
				v-model="addNewEntryDialogToForm"
				:close-on-click-modal="false"
				width='50%'
		>
			<el-form :model="addNewEntryForm" :rules="addNewEntryRules" ref="addNewEntryRef" label-width="160px"
			         style='min-width:800px'>
				<el-form-item label="合同编号:" prop="code">
					<el-input v-model='addNewEntryForm.code' clearable disabled></el-input>
				</el-form-item>
				<el-form-item label="项目名称:" prop="entryName">
					<el-input v-model='addNewEntryForm.entryName' clearable></el-input>
				</el-form-item>
				<!-- <el-form-item label="项目类型:" prop="entryType">
						<el-select v-model="addNewEntryForm.entryType" clearable>
								<el-option
										v-for="item in entryTypeArr"
										:key="item.value"
										:label="item.name"
										:value="item.value"
								>
								</el-option>
						</el-select>
						<span v-if="addNewEntryForm.entryType == 31">
								法定审结期限：15天
						</span>
						<span v-if="addNewEntryForm.entryType == 32 || addNewEntryForm.entryType == 33">
								法定审结期限：30天
						</span>
				</el-form-item> -->
				<!--        <el-form-item label="是否预审:" prop="isAntecedentTrial">-->
				<!--          <el-radio v-model="addNewEntryForm.isAntecedentTrial" label="false">否</el-radio>-->
				<!--          <el-radio v-model="addNewEntryForm.isAntecedentTrial" label="true">是</el-radio>-->
				<!--          <div style="margin-top: -15px;font-size: 12px;color: #888;">若选择为预审项目，则该项目的图审服务不计费</div>-->
				<!--        </el-form-item>-->
				<el-form-item label="项目分类:" prop="projectType">
					<el-select v-model="addNewEntryForm.projectType" clearable>
						<el-option
								v-for="item in projectTypeArr"
								:key="item.value"
								:label="item.name"
								:value="item.value"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="工程分类:" prop="engineeringType">
					<el-select v-model="addNewEntryForm.engineeringType" clearable>
						<el-option
								v-for="item in engineeringTypeArr"
								:key="item.value"
								:label="item.name"
								:value="item.value"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="审查时限:" prop="firstReportOverdueNums">
					<el-input class="areaSty" v-model='addNewEntryForm.firstReportOverdueNums' clearable></el-input>
					天 ( 三位图审工程师审图截止期限 )
				</el-form-item>
				<el-form-item label="复核时限:" prop="reviewReportOverdueNums">
					<el-input class="areaSty" v-model='addNewEntryForm.reviewReportOverdueNums' clearable></el-input>
					天 ( 技术部工程师意见汇总截止期限 )
				</el-form-item>
				<el-form-item label="审查报告编号(合格):" prop="customReportNo">
					<el-input v-model='addNewEntryForm.customReportNo' clearable></el-input>
				</el-form-item>
				<el-form-item label="审查报告编号(不合格):" prop="customFailReportNo">
					<el-input v-model='editEntryForm.customFailReportNo' clearable></el-input>
				</el-form-item>
				<el-form-item class="spacilTimer" label="承诺办结日期:" prop="settleTimer">
					<el-date-picker
							v-model="addNewEntryForm.settleTimer"
							type="date"
							placeholder="选择日期"
					>
					</el-date-picker>
					( 项目终审截止时间 )
				</el-form-item>
				<!-- <el-form-item label="政府承诺制审结期限:">
						<el-input v-model='addNewEntryForm.endTimer' clearable class="timerSty" :disabled="addNewEntryForm.noEndTimer"></el-input>
						天
						<el-checkbox v-model="addNewEntryForm.noEndTimer" class="noTimerSty">政府无承诺时间</el-checkbox>
				</el-form-item> -->
				<el-form-item label="图审面积:" prop="areaMeasure">
					<el-input class="areaSty" v-model='addNewEntryForm.areaMeasure' clearable></el-input>
					平方米
				</el-form-item>
				<el-form-item class="spacilTimer" label="项目说明:">
					<el-input v-model='addNewEntryForm.remark' type="textarea" :rows="3"></el-input>
					<div style="font-size: 12px;color: #888;">根据当地建设局要求表述</div>
				</el-form-item>
				<el-form-item label="项目联系人:" prop="entryContacts">
					<el-input v-model='addNewEntryForm.entryContacts' clearable></el-input>
				</el-form-item>
				<el-form-item label="手机号码:" prop="entryPhone">
					<el-input v-model='addNewEntryForm.entryPhone' clearable></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addNewEntryDialogToForm = false">取消</el-button>
				<el-button type="primary" @click="addNewEntrySubmit" :loading="addNewEntryLoading">确认</el-button>
			</div>
		</el-dialog>
		<!--底部工具条-->
		<el-col :span="24" class="pageBar">
			<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageIndex"
					:page-sizes="pages.pageArr"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pages.dataCount">
			</el-pagination>
		</el-col>
		<!-- 申请援助 -->
		<el-dialog
				title="申请援助"
				:visible.sync="applyForSendSMSDialog"
				v-model="applyForSendSMSDialog"
				:close-on-click-modal="false"
				width='50%'
		>
			<div class="projectName projectSelect">项目名称：{{ needData.projectName }}</div>
			<div class="projectSelect">
				<el-radio v-model="applyRadio" label="105">同时期任务重叠冲突，申请援助</el-radio>
			</div>
			<div class="projectSelect">
				<el-radio v-model="applyRadio" label="106">项目特殊，无法胜任，申请援助</el-radio>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="applyForSendSMSDialog = false">取消</el-button>
				<el-button type="primary" @click="applyForSendSMSubmit" :loading="applyForSendSMLoading">确定</el-button>
			</div>
		</el-dialog>
		<!-- 项目参与人员 -->
		<el-dialog
				:title="ParticipantsDialogName"
				:visible.sync="projectDelayDialog?projectDelayDialog:ParticipantsDialog"
				v-model="projectDelayDialog?projectDelayDialog:ParticipantsDialog"
				:close-on-click-modal="false"
				@close="colsedProjectDelay"
				width='70%'
		>
			<el-table
					:data="ParticipantsData"
					border
					style="width: 100%"
					v-loading="ParticipantsLoading"
					ref="ProjectDelayRef"
					:highlight-current-row='true'
					:cell-style="rowClass"
					@current-change="handleDelay"
			>
				<el-table-column prop="taskId" label="任务编号" width='100' align="center" ></el-table-column>
				<el-table-column prop="participationTypeName" width='140' label="类型" align="center"
				                 show-overflow-tooltip></el-table-column>
				<el-table-column prop="name" label="姓名" align="center" width='' show-overflow-tooltip>
					<template slot-scope='scope'>
						{{ scope.row.name }}
					</template>
				</el-table-column>
				
				<el-table-column prop="applyStatusName" label="状态" width='200' align="center" show-overflow-tooltip>
					<template #default="scope">
						{{scope.row.participationTypeName==='AI图审工程师'&&parseNum !== 'NaN%'&&parseNum !== undefined?(scope.row.applyStatusName+'('+parseNum+')'):scope.row.applyStatusName}}
					</template>
				</el-table-column>
				<el-table-column prop="signStatus" label="签署状态" width='160' align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="overdueDate" width='160' label="到期时间(晚)" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<template  v-if="!scope.row.completeDate && projectDelayDialog&&(scope.row.expertType===62||scope.row.expertType===63||scope.row.expertType===101)">
							<el-input v-model="scope.row.overdueDate" border="false"  :placeholder="scope.row.overdueDate" clearable @blur="addProjectDelay"></el-input>
						</template>
						<template  v-else>
							{{ scope.row.overdueDate }}
						</template>
					</template>
				</el-table-column>
				<el-table-column prop="completeDate" label="完成时间" width='170' align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="phoneNumber" label="手机号" width='150' align="center" show-overflow-tooltip></el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button v-if="projectDelayDialog" @click.native="projectDelayDialog = false">取消</el-button>
				<el-button v-else @click.native="ParticipantsDialog = false">取消</el-button>
			</div>
		</el-dialog>
		<!-- 复核报告 -->
		<el-dialog
				:title="reportORidea ? '复核报告' : '复核意见'"
				:visible.sync="reviewReportDialog"
				v-model="reviewReportDialog"
				:close-on-click-modal="false"
				width='50%'
		>
			<ReviewReport :projectId="preliminaryProjectId" :reportORidea="reportORidea" @reviewReportClick="reviewReportClick"></ReviewReport>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="reviewReportDialog = false">取消</el-button>
			</div>
		</el-dialog>
		<!-- 留言 -->
		<el-dialog
				title="留言"
				:visible.sync="leaveMessageDialog"
				v-model="leaveMessageDialog"
				:close-on-click-modal="false"
				width='50%'
		>
			<div class="projectTitle">项目名称：{{leaveMessageProjectName}}</div>
			<div v-for="(item,index) in leaveMessageArr" :key="index">
				<div>{{item.createUserName}}<span class="titleTimer">{{formatCreateTime(item.createTime)}}</span></div>
				<div style="margin: 5px 0px;">{{item.content}}</div>
				<div class="replyBtn" @click="replyMessageFun(item)">回复</div>
				<div class="replyMessage" v-for="(o,i) in item.reply" :key="i">
					<div>{{o.createUserName}}<span class="titleTimer">{{formatCreateTime(o.createTime)}}</span></div>
					<div><span v-if="o.replyUserName"> 回复 @{{o.replyUserName}} </span>{{o.content}}</div>
					<!-- <div v-for="(n,a) in o.reply" :key="a">{{n.createUserName}} 回复 @{{o.createUserName}} {{n.content}}</div> -->
					<div class="replyBtn" @click="replyMessageFun(o)">回复</div>
				</div>
			</div>
			<el-input type="textarea" style="margin-top:15px;" :rows="3" placeholder="请输入留言内容" v-model="leaveMessageContent">
			</el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="leaveMessageDialog = false">取消</el-button>
				<el-button type="primary" @click="leaveMessageSubmit" :loading="leaveMessageLoading">发表留言</el-button>
			</div>
		</el-dialog>
		<!-- 回复留言 -->
		<el-dialog
				title="回复留言"
				:visible.sync="replyPerMessageDialog"
				v-model="replyPerMessageDialog"
				:close-on-click-modal="false"
				width='50%'
		>
			<el-input type="textarea" style="margin-top:15px;" :rows="3" :placeholder="textareaStr" v-model="replyPerMessageContent"></el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="replyPerMessageDialog = false">取消</el-button>
				<el-button type="primary" @click="replyPerMessageSubmit" :loading="replyPerMessageLoading">发表留言</el-button>
			</div>
		</el-dialog>
		<!-- 审查意见 -->
		<el-dialog
				title="审查意见"
				:visible.sync="examinationsDialog"
				v-model="examinationsDialog"
				:close-on-click-modal="false"
				:destroy-on-close="true"
				width='70%'
		>
			<Examinations :projectId="componentProjectId" :isFirst="isFirst" :taskId="taskId"></Examinations>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="examinationsDialog = false">取消</el-button>
			</div>
		</el-dialog>
		<!-- 报告 -->
		<el-dialog
				title="报告"
				:visible.sync="preliminaryReportDialog"
				v-model="preliminaryReportDialog"
				:close-on-click-modal="false"
				:destroy-on-close="true"
				width='50%'
		>
			<PreliminaryReport :projectId="preliminaryProjectId"></PreliminaryReport>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="preliminaryReportDialog = false">关闭</el-button>
				<!-- <el-button type="primary" @click="preliminaryReportSubmit" :loading="preliminaryReportLoading">发起签章</el-button> -->
			</div>
		</el-dialog>
		<!-- 图审报告 -->
		<el-dialog
				title="终审报告"
				:visible.sync="dialogReportVisible"
				v-model="dialogReportVisible"
				:close-on-click-modal="false"
				:destroy-on-close="true"
				width='50%'
		>
			<AuditReportComponent :projectId="preliminaryProjectId"></AuditReportComponent>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="dialogReportVisible = false">关闭</el-button>
			</div>
		</el-dialog>
		<!-- 查看 -->
		<el-dialog
				title="查看"
				:visible.sync="viewsApplicationDialog"
				v-model="viewsApplicationDialog"
				:close-on-click-modal="false"
				:width='viewsApplicationWidth'
				:destroy-on-close="true"
				class="viewProject"
		>
			<ProjectView @activeChange="activeChange" :needData="needData"></ProjectView>
		</el-dialog>
		<el-dialog
				title="查看"
				:visible.sync="viewsApplicationDetailDialog"
				v-model="viewsApplicationDetailDialog"
				:close-on-click-modal="false"
				:width='viewsApplicationWidth'
				:destroy-on-close="true"
				class="viewProject"
		>
			<ProjectViewDetail  :needDataDetail="needDataDetailList" :needData="needData"></ProjectViewDetail>
		</el-dialog>
		
		<el-dialog
				title="修改项目"
				:visible.sync="addNewEntryDialog"
				v-model="addNewEntryDialog"
				:close-on-click-modal="false"
				width='60%'
		>
			<el-form :model="editEntryForm" :rules="editEntryRules" ref="addNewEntryRef" label-width="160px" style='min-width:200px'>
				
				<el-form-item class="spacilTimer" label="项目说明:">
					<el-input v-model='editEntryForm.remark' type="textarea" :rows="4"></el-input>
					<div style="font-size: 12px;color: #888;">根据当地建设局要求表述</div>
				</el-form-item>
				<el-form-item label="建设单位:" prop="customReportNo">
					<el-input v-model='editEntryForm.contractor' clearable></el-input>
				</el-form-item>
				<el-form-item label="工程地址:" prop="customReportNo">
					<el-input v-model='editEntryForm.address' clearable></el-input>
				</el-form-item>
				<el-form-item label="审查报告编号(合格):" prop="customReportNo">
					<el-input v-model='editEntryForm.customReportNo' clearable></el-input>
				</el-form-item>
				<el-form-item label="审查报告编号(不合格):" prop="customFailReportNo">
					<el-input v-model='editEntryForm.customFailReportNo' clearable></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addNewEntryDialog = false">取消</el-button>
				<el-button type="primary" @click="editEntrySubmit" :loading="addNewEntryLoading">确认</el-button>
			</div>
		</el-dialog>
		<!--修改项目系数-->
		<el-dialog
				title="修改项目"
				:visible.sync="editProjectContactDialog"
				v-model="editProjectContactDialog"
				:close-on-click-modal="false"
				width='60%'
		>
			<el-form :model="editContactEntryForm" :rules="editContactEntryFormRules" ref="addNewContactEntryRef" label-width="160px"
			         style='min-width:200px'>
				<el-form-item label="项目系数" prop="coefficient">
					<el-input v-model='editContactEntryForm.coefficient' clearable></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editProjectContactDialog = false">取消</el-button>
				<el-button type="primary" @click="editContactEntrySubmit" :loading="addNewEntryLoading">确认</el-button>
			</div>
		</el-dialog>
		
		<el-dialog
				title="重新审图"
				:visible.sync="resetDrawingReviewDialog"
				v-model="resetDrawingReviewDialog"
				:close-on-click-modal="false"
				width='60%'
		>
			<el-form :model="resetDrawingReviewForm" :rules="resetDrawingReviewRules" ref="resetDrawingReviewRef" label-width="160px" style='min-width:200px'>
				
				<el-form-item  label="项目名称:">
					<div style="font-size: 12px;color: #888;">{{resetDrawingReviewForm.projectName}}</div>
				</el-form-item>
				
				<el-form-item class="spacilTimer" label="审图到期时间(晚):" prop="overdueDate">
					<el-date-picker
							v-model="resetDrawingReviewForm.overdueDate"
							type="date"
							placeholder="选择日期"
							value-format="yyyy-MM-dd"
					>
					</el-date-picker>
				</el-form-item>
			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="resetDrawingReviewDialog = false">取消</el-button>
				<el-button type="primary" @click="resetDrawingReviewSubmit" :loading="resetDrawingReviewLoading">确认</el-button>
			</div>
		</el-dialog>
		
		<!-- 冻结状态 -->
		<el-dialog
				title="更改冻结状态"
				:visible.sync="freezeStatusDialog"
				v-model="freezeStatusDialog"
				:close-on-click-modal="false"
		>
			<el-form :model="freezeStatusForm"  ref="freezeStatusRef" label-width="150px" >
				<el-form-item label="变更冻结状态:">
					<el-radio-group v-model="freezeStatusForm.freezeStatus">
						<el-radio :label="57">冻结</el-radio>
						<el-radio :label="0">解冻</el-radio>
					</el-radio-group>
				</el-form-item>
			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="freezeStatusDialog = false">取消</el-button>
				<el-button type="primary" @click="freezeStatusSubmit" :loading="freezeStatusLoading">确认</el-button>
			</div>
		</el-dialog>
		<!-- 修改技术部专家 -->
		<el-dialog
				title="修改技术部专家"
				:visible.sync="techExpertDialog"
				v-model="techExpertDialog"
				:close-on-click-modal="false"
		>
			<el-form :model="techExpertForm" ref="techExpertRef" label-width="150px" :rules="techExpertRules"  >
				<el-form-item label="修改技术部专家:">
					<el-select placeholder="请选择" style="width: 300px;" prop="techExpertForm.assignedUserId" v-model="techExpertForm.assignedUserId" filterable>
						<el-option v-for="item in techExpertData" :key="item.userInfoId" :label="item.userName"
						           :value="item.userInfoId"></el-option>
					</el-select>
				</el-form-item>
			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="techExpertDialog = false">取消</el-button>
				<el-button type="primary" @click="techExpertSubmit" :loading="techExpertLoading">确认</el-button>
			</div>
		</el-dialog>
		
		<!-- 项目阶段明细 -->
		<el-dialog
				title="项目阶段明细"
				:visible.sync="stageDialog"
				v-model="stageDialog"
				:close-on-click-modal="false"
				width='80%'
		>
			<el-table
					:data="stageData"
					border
					style="width: 100%"
					v-loading="stageLoading"
					ref="multipleTable"
					:highlight-current-row='true'
					:cell-style="rowClass"
			>
				<el-table-column type='index' label="序号" width='60' align="center"></el-table-column>
				<el-table-column prop="stageName" width="120"  label="阶段名称" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="isPrequalification" label="是否预审" align="center" width="90">
					<template slot-scope='scope'>
						<el-tag v-if="scope.row.isPrequalification == true" type="success">是</el-tag>
						<el-tag v-if="scope.row.isPrequalification == false" type="danger">否</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="SendTime" label="参与人员" align="center" width="100">
					<template slot-scope='scope'>
						<el-button @click="viewsProjectStageUserInfo(needData.id,scope.row)" type="text">查看</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="assignUploadTime" width='140' label="上传资料时间" align="center" show-overflow-tooltip>
					<template slot-scope='scope'>
						{{scope.row.assignUploadTime ? scope.row.assignUploadTime.substr(0,10) : "" }}
					</template>
				</el-table-column>
				<el-table-column prop="assignUploadContent" width='160' label="重新申报的原因" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="assignUploadNodeId" label="项目图纸" align="center" width="90">
					<template slot-scope='scope'>
						<el-button @click="showProjectFile(needData,scope.row.assignUploadNodeId)" type="text">查看</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="assignUploadNodeId" label="申报表" align="center" width="90">
					<template slot-scope='scope'>
						<el-button @click="viewsApplicationDetail(scope.row)" type="text">查看</el-button>
					</template>
				</el-table-column>
				
<!--				<el-table-column prop="assignUploadNodeId" label="下载" align="center" width="90">-->
<!--					<template slot-scope='scope'>-->
<!--						<el-button v-if="scope.row.uploadFilePackUrl" @click="downloadFile(scope.row.uploadFilePackUrl)" type="text">下载</el-button>-->
<!--					</template>-->
<!--				</el-table-column>-->
<!--				-->
				<el-table-column prop="assignOpinionTime" width='160' label="意见提交时间" align="center" show-overflow-tooltip>
					<template slot-scope='scope'>
						{{scope.row.assignOpinionTime ? scope.row.assignOpinionTime.substr(0,10) : "" }}
					</template>
				</el-table-column>
				
				<el-table-column prop="assignOpinionNodeId" label="审查意见" align="center" width="90">
					<template slot-scope='scope'>
						<el-button v-if="scope.row.assignOpinionNodeId" @click="checkOpinonView(scope.row)" type="text">查看</el-button>
					</template>
				</el-table-column>
				
				<el-table-column prop="assignOpinionSummaryTime" width='160' label="意见汇总时间" align="center" show-overflow-tooltip>
					<template slot-scope='scope'>
						{{scope.row.assignOpinionSummaryTime ? scope.row.assignOpinionSummaryTime.substr(0,10) : "" }}
					</template>
				</el-table-column>
				
				<el-table-column prop="reportUrl" label="查看报告" align="center" >
					<template slot-scope='scope'>
						<el-button v-if="scope.row.reportUrl" @click="showReportFile(scope.row.reportUrl)" type="text">Word报告{{scope.row.reportPassStatus?'（合格）':'（不合格）'}}</el-button>
						<el-button v-else-if="scope.row.reportSignUrl" @click="showReportFile(scope.row.reportSignUrl)" type="text">签章报告{{scope.row.reportPassStatus?'（合格）':'（不合格）'}}</el-button>
						<el-button v-else-if="scope.row.stageName !== '初审'" @click="generateReport(scope.row)" type="text">未整改，复用上次意见书</el-button>
					
					</template>
				
				</el-table-column>
				
				<el-table-column prop="reportUrl" label="答疑" align="center" >
					<template slot-scope='scope'>
						<el-button v-if="scope.row.reportUrl" @click="viewsAnsweringDetail(scope.row)" type="text">答疑</el-button>
					</template>
				</el-table-column>
			
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="stageDialog = false">取消</el-button>
			</div>
		</el-dialog>
		
		<!-- 答疑详细展示 -->
		<el-dialog
				title="答疑详细"
				:visible.sync="viewMainansweringdialog"
				v-model="viewMainansweringdialog"
				:close-on-click-modal="false"
				width='60%'
		>
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane
						v-for="(tab, index) in distinctCount"
						:key="index"
						:label="tab.label"
						:name="tab.name"
				>
					<!-- 每个 tab 页的内容，可根据需求自定义 -->
<!--					{{ tab.label }}-->
				</el-tab-pane>
			</el-tabs>
			<el-form label-width="150px" v-for="item in activeList">
				<el-form-item label="提出人:">
					{{item.questioner}}
				</el-form-item>
				<el-form-item label="有疑问的意见:">
					{{item.reportContent}}
				</el-form-item>
				<el-form-item label="疑问内容:">
					{{item.reportContent}}
				</el-form-item>
				<el-form-item label="文件或图片:" >
					<template v-for = 'value in item.questionFileUrl.split(",")'>
						<el-button @click="viewFile(value)" type="text">{{value.split('|')[0]}}</el-button>
					</template>
				</el-form-item>
				<el-form-item label="答复内容:">
					({{item.answerer}}){{item.answerContent}}
				</el-form-item>
				<el-form-item label="答复的文件或图片:">
					<template v-for = 'value in item.answerFileUrl.split(",")'>
						<el-button @click="viewFile(value)" type="text">{{value.split('|')[0]}}</el-button>
					</template>
				</el-form-item>
				<el-divider></el-divider>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="viewdialogAnswer">取消</el-button>
			</div>
		</el-dialog>
		
<!--	添加答疑弹窗	-->
		<el-dialog
				title="答疑"
				:visible.sync="viewsAnsweringDialog"
				v-model="viewsAnsweringDialog"
				:close-on-click-modal="false"
				width='50%'
		>
			<el-form label-width="150px" :model="answeringForm" :rules="answeringFormRules" ref="answeringForm" >
				<el-form-item label="提出人:" prop="questioner">
					<el-select  v-model="answeringForm.questioner" style="width: 60%" placeholder="请选择提出人">
						<el-option
								v-for="(item,index) in questionerList"
								:key="index"
								:label="item.name"
								:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="有疑问的意见:" prop="reportId">
					<el-select  v-model="answeringForm.reportId" style="width: 60%" placeholder="请选择意见">
						<el-option
								v-for="(item,index) in opinionReportList"
								:key="index"
								:label="item.confirmProblem"
								:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="疑问内容:" prop="questionContent">
					<el-input v-model="answeringForm.questionContent" style="width: 60%" type="textarea" rows="5" placeholder="请输入疑问内容" ></el-input>
				</el-form-item>
				<el-form-item label="文件或图片:" >
					<el-upload
							class="upload-demo"
							:headers='headers'
							:action="questionUploadFile"
							:on-preview="handleQuestionPreview"
							:on-remove="handleQuestionRemove"
							:on-success="handleQuestionSuccess"
							:before-remove="beforeQuestionRemove"
							multiple
							:limit="30"
							:on-exceed="handleQuestionExceed"
							:file-list="questionFileList">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</el-form-item>
				<el-divider></el-divider>
				<el-form-item label="答复内容:" prop="answerContent">
					<el-input v-model="answeringForm.answerContent" style="width: 60%" type="textarea" rows="5" placeholder="请输入答复内容" ></el-input>
				</el-form-item>
				<el-form-item label="内容来源:" prop="answerer">
					<el-radio-group v-model="answeringForm.answerer">
						<el-radio label="客服">客服</el-radio>
						<el-radio label="专家">专家</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="文件或图片:" >
					<el-upload
							class="upload-demo"
							:headers='headers'
							:action="answeringUploadFile"
							:on-preview="handleAnsweringPreview"
							:on-remove="handleAnsweringRemove"
							:on-success="handleAnsweringSuccess"
							:before-remove="beforeAnsweringRemove"
							multiple
							:limit="30"
							:on-exceed="handleAnsweringExceed"
							:file-list="answeringFileList">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="viewsAnsweringDialog = false">取消</el-button>
				<el-button type="primary" @click.native="submitAnswering">提交</el-button>
			</div>
		</el-dialog>
		
		<!-- 查看审查意见 -->
		<el-dialog
				title="审查意见"
				:visible.sync="showOpinionDialog"
				v-model="showOpinionDialog"
				:close-on-click-modal="false"
				:destroy-on-close="true"
				width='80%'
		>
			<ShowOpinionComponent :aiDomainUrl = "aiDomainUrl" :nodeIds=" nodeIds" :projectId="showOpinionProjectId" :flowNodeId="showOpinionFlowNodeId" :groupRuleType="showGroupRuleType" ></ShowOpinionComponent>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="showOpinionDialog = false">取消</el-button>
			</div>
		</el-dialog>

		<el-dialog
				title="日志"
				:visible.sync="viewsLogDialog"
				v-model="viewsLogDialog"
				:close-on-click-modal="false"
				width='60%'
		>
		<el-table
					:data="viewsLogList"
					border
					style="width: 100%"
					v-loading="listLoading"
					ref="multipleTable"
					:highlight-current-row='true'
			>
				<el-table-column type='index' label="序号" width='60' align="center" :index='indexMethod'></el-table-column>
				<el-table-column prop="statusName" label="操作内容"  align="center" width="180" show-overflow-tooltip></el-table-column>
				<el-table-column prop="userName" label="操作人" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="createTime" label="操作时间" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="ip" label="IP" align="center" show-overflow-tooltip></el-table-column>
				
			</el-table>
		</el-dialog>
<!--	更换在线专家	-->
		<el-dialog
				title="更换在线专家"
				:visible.sync="replaceBoolean"
				v-model="replaceBoolean"
				:close-on-click-modal="false"
				:destroy-on-close="true"
				width='40%'
		>
			<el-form  label-width="150px"  v-for="(item,index) in replaceOnlineList">
				<el-form-item  :label="'请选择在线专家'+(index+1)"  >
					<el-select @change="(val) => handleSelectChange(val, index)" v-model="item.expertId" placeholder="请选择在线专家">
						<el-option
								v-for="item in onlineExpertList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="replaceBoolean = false">关闭</el-button>
<!--				<el-button type="primary" @click.native="replaceExpert">确定</el-button>-->
			</div>
		</el-dialog>
		
		<!-- 查看项目图纸 -->
		<el-dialog
				title="项目图纸"
				:visible.sync="projectFileDialog"
				v-model="projectFileDialog"
				:close-on-click-modal="false"
				:destroy-on-close="true"
				width='90%'
		>
			<!-- <div style="margin: 0 auto;">
				<el-tree
						:data="projectFileData"
						node-key="id"
						default-expand-all
						:props="projectFileProps"
						style="max-height: 450px;overflow-y: auto;overflow-x: auto;"
				>
					 <span class="custom-tree-node" slot-scope="{ node, data }">
        
        <span v-if="data.childFiles === null">
          <el-button
		          type="text"
		          size="mini"
		          @click="() => append(data)">
            {{ node.label }}
          </el-button>
        </span>
					<span v-else>{{ node.label }}</span>
      </span>
				</el-tree>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="projectFileDialog = false">取消</el-button>
			</div> -->
			<ProjectDrawing  :isDisabled="true" :needData="needData" :flowNodeId="lastUploadFlowNodeId"></ProjectDrawing>
		</el-dialog>
		
<!--	添加意见	-->
		<el-dialog
				title="项目图纸添加意见"
				:visible.sync="viewOpinionDialog"
				v-model="viewOpinionDialog"
				:close-on-click-modal="false"
				:destroy-on-close="true"
				width='60%'
		>
			<div style="margin: 0 auto;">
				<el-tree
						:data="projectFileDataOpinion"
						node-key="id"
						default-expand-all
						:props="projectFilePropsOpinion"
						style="max-height: 450px;overflow-y: auto;overflow-x: auto;"
				>
					 <span class="custom-tree-node" slot-scope="{ node, data }">
        
        <span v-if="data.childFiles === null">
          <el-button
		          type="text"
		          size="mini"
		          @click="() => addOpinion(data)">
            ({{data.opinionNums ? data.opinionNums : 0}}){{ node.label }}
          </el-button>
	        <!--          <el-button-->
	        <!--		          type="text"-->
	        <!--		          size="mini"-->
	        <!--		          @click="() => remove(node, data)">-->
	        <!--            Delete-->
	        <!--          </el-button>-->
        </span>
					<span v-else>{{ node.label }}</span>
      </span>
				</el-tree>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="viewAllOpinion" >查看所有意见</el-button>
				<el-button @click="submitAllOpinion">完成审查，提交所有意见</el-button>
				<el-button @click.native="viewOpinionDialog = false">取消</el-button>
			</div>
		</el-dialog>
		
<!--	查看所有意见	-->
		<el-dialog
				title="查看所有意见"
				:visible.sync="viewAllOpinionDialog"
				v-model="viewAllOpinionDialog"
				:close-on-click-modal="false"
				width='70%'
		>
			<!-- 循环渲染多条意见 -->
			<div class="opinion-list" v-if="opinionList.length > 0">
				<div
						class="opinion-item"
						v-for="(opinion, index) in opinionList"
						:key="index">  <!-- 实际项目中建议使用唯一ID（如opinion.id）作为key，性能更优 -->
					<!-- 中间意见内容 -->
					<div class="opinion-content">
						<div style="display: flex; align-items: center; flex-wrap: wrap; word-break: break-all;line-height: 1.2 ">
							{{index + 1}}、
							<el-tag type="success" size="small">{{ opinion.userName }}</el-tag>
							
							<div v-if="isEdit&&opinionId === opinion.id">
								<el-input
										style="min-width:800px;"
										v-model="opinion.specificOpinions"
										type="textarea"
										rows="2"
										placeholder="请输入内容"
								/>
							</div>
							<div v-else>{{ opinion.specificOpinions }}</div>
							<div >{{ opinion.drStandardItemDescribe }}</div>
<!--							<div>({{opinion.ddIdQuestionPropertieValue}})</div>-->
							<div>({{opinion.itemType == '1' ? '重要事项' : opinion.itemType == '9' ? '其他事项' : opinion.itemType == '99' ? '提示事项' : ''}})
							</div>
						</div>
						<el-button type="text" @click="viewFilePath(opinion)">位置：{{ opinion.drProjectFilePath }}</el-button>
					</div>
					
					<!-- 右侧操作按钮 -->
					
					<div class="opinion-actions" v-if="isEdit&&opinionId === opinion.id">
						<el-button type="success" size="small" @click="saveOpinion(index, opinion)">保存</el-button>
						<el-button type="primary" size="small" @click="cancelEdit(index, opinion)">取消</el-button>
					</div>
					<div class="opinion-actions" v-else>
						<el-button type="primary" size="small" @click="editOpinion(opinion)">编辑</el-button>
						<el-button type="danger" size="small" @click="deleteOpinion(index, opinion)">删除</el-button>
					</div>
				</div>
			</div>
			<el-empty v-else description="暂无数据"></el-empty>
		</el-dialog>
		
		<el-dialog
				title="查看所有意见"
				:visible.sync="viewFilePathDialog"
				v-model="viewFilePathDialog"
				:close-on-click-modal="false"
				width='50%'
		>
			<el-image :src="viewlFilePathUrl"
					style="width: 100%; height: 100%"
			></el-image>
		</el-dialog>
		
		
		<el-dialog
				title="添加意见"
				:visible.sync="addOpinionDialog"
				v-model="addOpinionDialog"
				:fullscreen="true"
				:close-on-click-modal="false"
				:destroy-on-close="true"
				width='90%'
		>
				<div style="margin: 0 auto;">
					<PdfScreenshotViewer
							:pdf-url="pdfUrl"
							:needDataItem="drawingData"
							:initial-zoom="1"
					/>
				</div>
		</el-dialog>
		
		<!-- 亮灯提醒 -->
		<!--        <div class="specialReminder" v-if="isSpecialReminder && isShowReminder">-->
		<!--            <div class="reminderBtn">-->
		<!--                <div style="cursor: pointer;" @click="minimizeReminder">—</div>-->
		<!--            </div>-->
		<!--            <div style="text-align: center;font-size: 16px;">倒计时</div>-->
		<!--            <div class="projectPra">-->
		<!--                <div class="projectBox">-->
		<!--                    <div class="projectList" v-for="(item,index) in projectList" :key="index">距<span class="projectName">{{item.projectName}}</span>项目承诺办结日期<span class="projectDay">{{item.projectPeriodExpireDay}}天</span></div>-->
		<!--                </div>-->
		<!--            </div>-->
		<!--        </div>-->
		<div class="miniBox" @click="maxsizeReminder" v-if="!isSpecialReminder && isShowReminder">
			<div class="miniNodes">
			
			</div>
		</div>
	</div>
</template>

<script>
import util from '../../../util/date'
import Toolbar from '../../components/Toolbar'
import { getButtonList } from '../../promissionRouter'
import {
	getCompressedProjectFile,
	conclusionProject,
	applyAssistance,
	getProjectMessageByProjectId,
	getProjectParticipantsOld,
	addProjectMessage,
	getAreaDictionaryList,
	getProjectConclusionExpire,
	signatureProject,
	updateProjectInfo,
	resetDrawingReviewApi,
	getStageListByProjectId,
	getProjectFileInfoByFlowNodeId,
	convertFormalProject,
	changeTaskOverdueDate,
	changeAssignedUserIdByTechExpert,
	aiDoLogin,
	getByNamespace,
	getProjectApplicationByProjectId,
	updateProjectApplication,
	getProjectList,
	generateTemporaryUrlByFileName,
	getDrContractList,
	generationPreviousDrawingReviewReport,
	changeKYJCTaskUserId,
	getSameKYJCProjectListByGeo,
	getProjectFileInfo,
	getOpinionSummaryReportList,
	uploadFile,
	addOpinionSummaryReportGuestbook,
	getOpinionSummaryReportGuestbookList,
	getOpinionAllList,
	updateSpecificOpinion,
	deleteOpinion,
	submitDrawingReviewReport,
	getOpinionListByWorkFlowId,
	isFinishTaskByProjectId,
	getProjectOperationLogList
} from '@/api/api'
import ProjectView from '../drProjectManager/projectView.vue'
import ProjectDrawing from "../drProjectManager/projectDrawing.vue";
import Examinations from './examinationsComponent.vue'
import PreliminaryReport from './preliminaryReportComponent.vue'
import AuditReportComponent from './auditReportComponent'
import ReviewReport from './reviewReportComponent.vue'
import ShowOpinionComponent from './showOpinionComponent'
import WordTable from '@/views/drProjectManager/wordTable.vue'
import { isDigit, isValidContactNumber, validPhone } from '../../../util/validate'
import axios from 'axios';
import PdfScreenshotViewer from '@/components/PdfScreenshotViewer.vue';
import ProjectViewDetail from "@/views/drProjectManager/projectViewDetail.vue";

export default {
	components: {
		ProjectViewDetail,
		ProjectDrawing,
		Toolbar,
		ProjectView,
		Examinations,
		PreliminaryReport,
		ReviewReport,
		AuditReportComponent,
		ShowOpinionComponent,
		WordTable,
		PdfScreenshotViewer
	},
	data () {
		//验证手机号
		let isPhoneNumberNum = (rule, value, callback) => {
			if (!validPhone(value)) {
				return callback(new Error("请输入正确的手机号"));
			} else {
				callback();
			}
		};
		return {
			isEdit:false,
			opinionId:undefined,
			opinionList: [
			
			],
			
			viewAllOpinionDialog:false,
			distinctCount: undefined,
			activeAllList:[],
			activeList:[],
			activeName:'1',
			viewMainansweringdialog:false,
			questionUploadFile:'',
			answeringUploadFile:'',
			questionFileList:[],
			answeringFileList:[],
			questionFile:[],
			answeringFile:[],
			opinionReportList:undefined,
			//答疑Object
			answeringForm:{
				questioner:undefined,///提问人
				reportId:undefined,//报告ID
				drProjectId :undefined,//项目ID
				workFlowNodeId :undefined,//流程节点ID
				questionContent :undefined,//提问内容
				questionFileUrl :undefined,//答复文件 格式（文件名1|文件1URL,文件名2|文件2URL）
				answerer :undefined,//回复人
				answerContent:undefined,//答复内容
				answerFileUrl:undefined,//答复文件 格式（文件名1|文件1URL,文件名2|文件2URL）
			},
			answeringFormRules : {
				questioner: [
					{ required: true, message: '请选择提问人', trigger: 'change' }
				],
				questionContent: [
					{ required: true, message: '请输入提问内容', trigger: 'blur' }
				],
				reportId: [
					{ required: true, message: '请选择报告', trigger: 'change' }
				],
				answerer: [
					{ required: true, message: '请选择回复人', trigger: 'change' }
				],
				answerContent: [
					{ required: true, message: '请输入答复内容', trigger: 'blur' }
				]
			},
			questionerList:[
					{
						value:'申报单位',
						name:'申报单位'
					},
					{
						value:'设计院',
						name:'设计院'
					},
					{
						value:'消防大队',
						name:'消防大队'
					}
			],
			//答疑弹窗
			viewsAnsweringDialog:false,
			pdfUrl:'',
			viewsSimilarProjectList:[],
			replaceOnlineList:[],
			replaceOnlineList1:[],
			replaceExpertId:undefined,
			onlineExpertList:[{"id":349,"name":"刘金刚"},{"id":350,"name":"庞建军"},{"id":351,"name":"郭营"},{"id":352,"name":"李红蕾"},{"id":353,"name":"冷启贞"},{"id":354,"name":"李宝萍"},{"id":355,"name":"邢佳佳"},{"id":322,"name":"杨健鹏"}],
			ddIdVenueNature:[],
			needdDataDelay:[],
			projectDelayContent:'',
			// viewRow:{},
			addNewEntryDialogToForm:false,
			engineeringTypeArr: [
				{ name: "特殊建设工程", value: 157 },
				{ name: "其他建设工程", value: 158 },
			],
			projectTypeArr: [
				{ name: "新建项目", value: 31 },
				{ name: "扩建项目", value: 32 },
				{ name: "改造项目", value: 33 },
			],
			addNewEntryRules: {
				code: [{ required: true, message: '请输入合同编号', trigger: 'blur' }],
				entryName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
				entryType: [{ required: true, message: '请选择项目类型', trigger: 'blur' }],
				endTimer: [{ message: '请输入政府承诺制审结期限', trigger: 'blur' }],
				areaMeasure: [{ required: true, message: '请输入图审面积', trigger: 'blur' }],
				entryContacts: [{ required: true, message: '请输入项目联系人', trigger: 'blur' }],
				entryPhone: [
					{ required: true, message: '请输入手机号码', trigger: 'blur' },
					{ validator: isPhoneNumberNum },
				],
				// 20230208新加
				// isAntecedentTrial: [{ required: true, message: '请选择是否预审', trigger: 'blur' }],
				projectType: [{ required: true, message: '请选择项目分类', trigger: 'blur' }],
				engineeringType: [{ required: true, message: '请选择工程分类', trigger: 'blur' }],
				settleTimer: [{ required: true, message: '请选择办结日期', trigger: 'blur' }],
				firstReportOverdueNums: [
					{ required: true, message: '请输入审查时限', trigger: 'blur' },
					{ validator: isDigit },
				],
				reviewReportOverdueNums: [
					{ required: true, message: '请输入复核时限', trigger: 'blur' },
					{ validator: isDigit },
				],
			},
			addNewEntryForm: {
				code: "",
				entryName: "",
				entryType: "",
				endTimer: "",
				noEndTimer: false,
				areaMeasure: "",
				remark: "",
				entryContacts: "",
				entryPhone: "",
				// 20230208新加
				// isAntecedentTrial: "false",
				projectType: "",
				engineeringType: "",
				settleTimer: "",
				customReportNo: "",
				firstReportOverdueNums: 1,
				reviewReportOverdueNums: 1,
			},
			projectRegisterDialog: false,
			viewsSimilarProjectDialog:false,
			utils: '',
			buttonList: [],
			needData: '',
			needDataDetail: '',
			needDataDetailList: '',
			filters: {
				keyWord: '',
				contractId:undefined,
				areaStr: '',
				entyType: ['45,46,52,53,140,141'],
				entyStatus:'35,50',
				excludeTestArea:1,
				techExpertUserId:undefined,
				ddKeyGroupRule:undefined,
				isFirstAuditSubmit:1,
			},
			auditArr:[
				{ name: '全部', value: 0 },
				{ name: '待审查', value: 1 },
			],
			smsTemplateArr: [],
			pushTemplateArr: [],
			textAreas: [
				{ name: '全部', value: 0 },
				{ name: '排除测试地区', value: 1 },
			],
			teachUserArr: [
				{ name: '刘金刚', value: 31 },
				{ name: '庞建军', value: 252 },
				{ name: '郭营', value: 239 },
				{ name: '李红蕾', value: 238 },
				{ name: '冷启贞', value: 30 },
				{ name: '李宝萍', value: 312 },
				{ name: '杨健鹏', value: 244 },
				{ name: '邢佳佳', value: 1085 },
				{ name: '孟明', value: 1438 },
				{ name: '芦旭东', value: 1439 },
				{ name: '吴国妹', value: 1441 },
				{ name: '毛燕君', value: 1442 },
				{ name: '曾利英', value: 1443 },
				{ name: '王丽', value: 1444 },
			],
			rulersArr:[
				{name:'规则一',value:1},
				{name:'规则二',value:2},
				{name:'规则三',value:3},
			],
			areaArr: [
				{ name: '上海', value: 0 },
				{ name: '浙江', value: 1 },
				{ name: '安徽', value: 2 },
			],
			entyTypeArr: [
				{ name: '未审结', value: '45,46,52,53,140,141' },
				{ name: '待受理', value: '35,50' },
				{ name: '退回整改', value: '10' },
				{ name: '待提交', value: '0' },
				{ name: '已审结', value: '55' },
			],
			sendCrowdPage: {
				DataCount: 10,
			},
			sendCrowdArr: [],
			tableData: [],
			listLoading: false,
			//关于分页的obj
			pages: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			// 申请援助
			applyForSendSMSDialog: false,
			applyForSendSMLoading: false,
			applyRadio: '',
			// 项目参与人员
			ParticipantsDialogName: '项目参与人员',
			ParticipantsDialog: false,
			ParticipantsLoading: false,
			ParticipantsData: [],
			// 复核报告/意见
			reportORidea: true,
			reviewReportDialog: false,
			reviewTableLoading: false,
			// reviewReportData: [],
			// reviewReportId: '',
			taskId: '',
			// 留言
			leaveMessageDialog: false,
			leaveMessageLoading: false,
			leaveMessageProjectName: '',
			replyId: 0,
			leaveMessageArr: [],
			leaveMessageContent: '',
			// 回复留言
			replyPerMessageDialog: false,
			replyPerMessageLoading: false,
			replyPerMessageContent: '',
			textareaStr: '请输入回复内容',
			// 审查意见
			examinationsDialog: false,
			componentProjectId: '',
			isFirst: '',
			// 初审报告
			preliminaryReportDialog: false,
			preliminaryReportLoading: false,
			preliminaryProjectId: '',
			isQualified: [],
			dialogReportVisible: false,
			// 项目查看
			viewsApplicationDialog: false,
			viewsApplicationDetailDialog: false,
			viewsApplicationWidth: '1200px',
			// 亮灯提醒
			isSpecialReminder: true,
			isShowReminder: false,
			projectList: [],
			//项目系数编辑
			editProjectContactDialog:false,
			// 项目编辑
			addNewEntryDialog: false,
			addNewEntryLoading: false,
			editEntryForm: {
				remark: '',
				address:undefined,
				contractor:undefined,
				customFailReportNo:undefined,
				customReportNo:undefined,
				id:undefined,
			},
			editContactEntryForm: {
				coefficient:''
			},
			editEntryRules: {
				remark: [{ required: true, message: '请输入合同编号', trigger: 'blur' }],
			},
			editContactEntryFormRules: {
				coefficient: [{ required: true, message: '请输入大于等于0的有效数字，且小数点后只保留两位的有效数字', trigger: 'blur' }, { validator: isValidContactNumber }],
			},
			// 重新审图
			resetDrawingReviewDialog: false,
			resetDrawingReviewLoading: false,
			resetDrawingReviewForm: {
				overdueDate: '',
				projectName: '',
			},
			resetDrawingReviewRules: {
				overdueDate: [{ required: true, message: '请输入审图过期时间', trigger: 'blur' },{}],
			},
			// 阶段明细
			stageDialog: false,
			stageLoading: false,
			stageData: [],
			// 显示图审报告
			showOpinionDialog: false,
			showOpinionProjectId: '',
			aiDomainUrl:undefined,
			nodeIds:undefined,
			showOpinionFlowNodeId: '',
			showGroupRuleType: 0,
			// 查看图纸
			projectFileDialog: false,
			projectFileLoading: false,
			projectFileData: [],
			projectFileDataOpinion: [],
			viewOpinionDialog: false,
			addOpinionDialog: false,
			projectFileProps: {
				children: 'childFiles',
				label: 'fileName',
			},
			projectFilePropsOpinion: {
				children: 'childFiles',
				label: 'fileName',
			},
			// 冻结状态
			freezeStatusDialog: false,
			freezeStatusLoading: false,
			freezeStatusForm:{
				freezeStatus:0
			},
			projectDelayDialog:false,
			// 修改技术部专家
			techExpertData: [{"userInfoId":30,"userName":"冷启贞-总部-技术部-工程师"},{"userInfoId":31,"userName":"刘金刚-总部-技术部-工程师"},{"userInfoId":238,"userName":"李红蕾-总部-技术部-工程师"},{"userInfoId":239,"userName":"郭营-总部-技术部-工程师"},{"userInfoId":244,"userName":"杨健鹏-总部-技术部-工程师"},{"userInfoId":252,"userName":"庞建军-总部-技术部-工程师"},{"userInfoId":312,"userName":"李宝萍-总部-技术部-工程师"}],
			techExpertDialog: false,
			techExpertLoading: false,
			techExpertForm: {
				assignedUserId: undefined,
			},
			techExpertRules:{
				assignedUserId: [{ required: true, message: '请选择专家', trigger: 'blur' },{}]
			},
			domain:undefined,
			aiToken:undefined,
			parseNum:undefined,
			ddIdContractList:[],
			replaceBoolean:false,
			drawingData:undefined,
			viewFilePathDialog:false,
			viewlFilePathUrl:undefined,
			viewsLogDialog:false,
			viewsLogList:[],
			lastUploadFlowNodeId:undefined,
		}
	},
	methods: {
		cancelEdit () {
			this.isEdit = false;
		},
		saveOpinion (index , opinion) {
			let params = {
				id: opinion.id,
				specificOpinions: opinion.specificOpinions,
			}
			updateSpecificOpinion(params).then(res => {
				if (res.data.success) {
					this.$message.success('保存成功！');
					this.viewAllOpinion();
					this.isEdit = false;
				}else {
					this.$message.error(res.data.message);
				}
			})
		},
		viewFilePath(item){
			// window.open(item.positionImg)
			this.viewlFilePathUrl = item.positionImg;
			this.viewFilePathDialog = true;
		},
		// 编辑意见（可扩展真实编辑逻辑）
		editOpinion(opinion) {
			this.isEdit = true;
			this.opinionId = opinion.id;
			console.log("编辑意见：", opinion);
			// 后续可添加打开编辑弹窗、回显数据等逻辑
		},
		// 删除意见（可扩展真实删除逻辑）
		deleteOpinion(index, opinion) {
			console.log("删除意见：", opinion);
			// 确认删除（可选，提升用户体验）
			this.$confirm("确定要删除这条意见吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let params = {
					id: opinion.id,
				};
				deleteOpinion(params).then(res => {
					if (res.data.success) {
						this.$message.success('删除成功！');
						this.viewAllOpinion();
					}
				})
			}).catch(() => {
				this.$message({
					type: "info",
					message: "已取消删除"
				});
			});
		},
		
		async viewAllOpinion(){
			await this.viewAllOpinions()
			this.viewAllOpinionDialog = true;
		},
		viewAllOpinions(){
			let param = {
				projectId: this.needData.id
			}
			getStageListByProjectId(param).then(res => {
				let result = res.data
				if(result) {
					const stageData = result.response ? result.response[result.response.length - 1] : undefined;
					// console.log(this.stageData);
					let params = {
						projectId: this.needData.id,
						workNodeId:stageData.assignOpinionNodeId
					};
					getOpinionListByWorkFlowId(params).then(res => {
						if (res.data.success) {
							this.opinionList = res.data.response;
						}
					});
					
				} else {
					this.$message.error("加载失败！")
				}
				this.stageLoading = false
			})
		},
		submitAllOpinion(){
			this.$confirm("提交图审意见后所有问题即刻流转至技术部汇总！是否确认？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let params = {
					projectId: this.needData.id,
				};
				submitDrawingReviewReport(params).then(res => {
					if (res.data.success) {
						this.$message.success('提交成功！');
						this.viewAllOpinionDialog = false;
						this.getProjectList()
					}
				})
			});
		},
		
		viewdialogAnswer(){
			this.viewMainansweringdialog = false
		},
		viewFile( file){
			window.open(file.split('|')[1])
		},
		async handleClick(tab, event){
			console.log(tab.index, event);
			await this.viewsAnsweringList(this.needData,tab.index)
		},
		async submitAnswering(){
			this.$refs.answeringForm.validate(valid => {
				if (valid) {
					// if (! (this.questionFile && this.questionFile.length > 0)){
					// 	this.$message.error('请上传问题文件！');
					// 	return;
					// }
					// if (! (this.answeringFile && this.answeringFile.length > 0)){
					// 	this.$message.error('请上传问题文件！');
					// 	return;
					// }
					let params = {
						questioner:this.answeringForm.questioner,///提问人
						reportId:this.answeringForm.reportId,//报告ID
						drProjectId :this.needData.id,//项目ID
						workFlowNodeId :this.needDataDetail.assignOpinionSummaryNodeId,//流程节点ID
						questionContent :this.answeringForm.questionContent,//提问内容
						questionFileUrl :this.questionFile.join(','),//答复文件 格式（文件名1|文件1URL,文件名2|文件2URL）
						answerer :this.answeringForm.answerer,//回复人
						answerContent:this.answeringForm.answerContent,//答复内容
						answerFileUrl:this.answeringFile.join(','),//答复文件 格式（文件名1|文件1URL,文件名2|文件2URL）
					}
					addOpinionSummaryReportGuestbook(params).then(res => {
						if (res.data.success) {
							this.$message.success('提交成功！');
							this.viewsAnsweringDialog = false;
						}else {
							this.$message.error(res.data.message);
						}
					})
				}
			})
			
		},
		handleQuestionRemove(file, fileList,index) {
			console.log(file, fileList);
			this.questionFile =this.questionFile.splice(index, 1)
		},
		handleQuestionPreview(file) {
			console.log(file);
		},
		handleQuestionExceed(files, fileList) {
			this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		beforeQuestionRemove(file, fileList) {
			return this.$confirm(`确定移除 ${ file.name }？`);
		},
		handleQuestionSuccess(res){
			if (res.success) {
				// console.log(res,'successRes')
				const result = res.response.sourceName+"|"+res.response.weburl
				this.questionFile.push(result)
			}else {
				this.$message.error(res.message);
			}
		},
		
		handleAnsweringRemove(file, fileList,index) {
			this.answeringFile =this.answeringFile.splice(index, 1)
			console.log(file, fileList);
		},
		handleAnsweringPreview(file) {
			console.log(file);
		},
		handleAnsweringExceed(files, fileList) {
			this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		beforeAnsweringRemove(file, fileList) {
			return this.$confirm(`确定移除 ${ file.name }？`);
		},
		handleAnsweringSuccess(res){
			if (res.success) {
				const result = res.response.sourceName+"|"+res.response.weburl
				this.answeringFile.push(result)
			}else {
				this.$message.error(res.message);
			}
		},
		// 查看日志
		viewsLog(item){
			let params = {
				projectId:item.id,
			}
			getProjectOperationLogList(params).then(res=>{
				if (res.data.success){
					this.viewsLogList = res.data.response
				}
			})
			this.viewsLogDialog = true ;
		},
		//主列表答疑
		viewsAnswering(item){
			this.viewsAnsweringList(item,1)
			this.viewMainansweringdialog = true ;
		},
		async viewsAnsweringList(item,num){
			let params = {
				projectId:item.id,
			}
			const res = await getOpinionSummaryReportGuestbookList(params)
			if (res.data.success){
				this.activeList = res.data.response.filter(item => item.flowNum == num)
				console.log(this.activeList,'activeListdddddddddd')
				const distinctActiveList = [...new Set(res.data.response.map(item => item.flowNum))];
				
				
				this.distinctCount = distinctActiveList.map((_, index) => {
					let label = "";
					if (index === 0) {
						label = "初审"; // 第一个不同值对应“初审”
					} else {
						label = `复审${index}`; // 后续对应“复审一、复审二...”（index从1开始）
					}
					return {
						label: label,
						name: (index + 1).toString(), // name 按 1、2、3... 命名
					};
				});
				// 3. 如果有动态 tabs，默认激活第一个
				if (this.dynamicTabs.length > 0) {
					this.activeName = this.dynamicTabs[0].name;
				}
				
				
			}
		},
		//详细答疑
		async viewsAnsweringDetail(item){
			this.answeringForm={
				questioner:undefined,///提问人
				reportId:undefined,//报告ID
				drProjectId :undefined,//项目ID
				workFlowNodeId :undefined,//流程节点ID
				questionContent :undefined,//提问内容
				questionFileUrl :undefined,//答复文件 格式（文件名1|文件1URL,文件名2|文件2URL）
				answerer :undefined,//回复人
				answerContent:undefined,//答复内容
				answerFileUrl:undefined,//答复文件 格式（文件名1|文件1URL,文件名2|文件2URL）
			}
			this.questionFileList = []
			this.answeringFileList = []
			this.needDataDetail = item
			let params = {
				projectId:this.needData.id,
				flowNodeId:item.assignOpinionSummaryNodeId,
			}
			const res = await getOpinionSummaryReportList(params)
			if (res.data.success){
				this.opinionReportList = res.data.response
			}
			this.viewsAnsweringDialog = true
		},
		viewsSimilarProject(val){
			let params = {
				projectId:val.id,
				range: 300,
			}
			getSameKYJCProjectListByGeo(params).then(res=>{
				if (res.data.success){
					this.viewsSimilarProjectList = res.data.response
				}
			})
			this.viewsSimilarProjectDialog = true
		},
		handleSelectChange(value, index) {
			console.log(`第 ${index + 1} 个专家选择器的值变为:`, value);
			this.$alert(`确定替换在线专家${index+1}？`, '更换在线专家', {
				confirmButtonText: '确定',
				callback: action => {
					if (this.replaceOnlineList.find(obj => String(obj.id) === String(value))!== undefined) {
					  this.$message.error('不可更换已选择在线专家！');
					  return;
					}
					console.log(333+'wwwwww33333')
					const valueTask = this.replaceOnlineList.filter(item=>item.expertId===value)[0]
					console.log(valueTask,'valueTask')
					let params = {
						taskId: valueTask.taskId,
						changeUserId: value,
					};
					console.log(33333333)
					changeKYJCTaskUserId(params).then(res => {
						// if (res.data.success) {
						//   this.$message.success('更换成功！');
						//   this.replaceOnlineSpecialistList();
						// } else {
						//   this.$message.error('更换失败，请稍后再试。');
						// }
					}).catch(err => {
						console.error('更换专家失败:', err);
						this.$message.error('网络异常，请检查接口请求');
					});
					
				}
			});
			

		},
		//更换在线专家
		replaceOnlineSpecialist(){
			if (this.needData){
				// if (this.needData.ddIdProjectStatus === 45){
				if (true){
					this.replaceOnlineSpecialistList()
					this.replaceBoolean  = true;
				}else {
					this.$message({
						message: '只有初审意见填写阶段才可更改在线专家！',
						type: 'error'
					})
				}
			}else {
				this.$message({
					message: '请选择项目！',
					type: 'error'
				})
			}
		},
		replaceOnlineSpecialistList(){
			this.replaceOnlineList = []
			let params = {
				projectId: this.needData.id
			}
			getProjectParticipantsOld(params).then(res => {
				let result = res.data
				if (result) {
					const onList = [...result.response]
					this.replaceOnlineList = onList.filter(item=> item.expertType === 63).map(item=>({
						...item,
						expertId:item.id,
					}))
					
				}
			})
		},
		replaceExpert(){
			console.log(this.replaceExpertId,'replaceExpertId');
		},
		//查看图纸
		append(data){
			if (data){
				let params = {
					fileName:data.filePath.split('.com/')[1],
				}
				generateTemporaryUrlByFileName(params).then(res => {
					window.open(res.data)
				})
				console.log(data,'drawingData')
			}else{
				this.$message({
					message: '此图纸无文件！',
					type: 'error'
				})
			}
		},
		addOpinion(data){
			if (data){
				let params = {
					fileName:data.filePath.split('.com/')[1],
				}
				generateTemporaryUrlByFileName(params).then(res => {
					this.pdfUrl = res.data
					
					// 生成路由完整路径
					const routeData = this.$router.resolve({
						path: '/AddOpinion',
						query: {
							data: JSON.stringify(data),
							pdfUrl: res.data,
							projectName: data.projectName || data.fileName || '添加意见' // 传递项目名称
						}
					});
					// 打开新窗口
					window.open(routeData.href, '_blank');
					
					// this.addOpinionDialog = true
				})
				console.log(data,'drawingData')
				this.drawingData = data
			}else{
				this.$message({
					message: '此图纸无文件！',
					type: 'error'
				})
			}
		},
		//快速生成报告
		generateReport(row){
			this.$confirm('确定要生成报告吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const loading = this.$loading({
					lock: true,
					text: '生成中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				generationPreviousDrawingReviewReport({projectId:this.needData.id}).then(res => {
					if(res.data.success){
						this.$message({
							message: res.data.message,
							type: 'success'
						})
						this.viewStageList(this.needData)
						loading.close();
					}else{
						this.$message({
							message: res.data.message,
							type: 'error'
						})
						loading.close();
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				})
			})
		
			// if (!this.needData){
			// 	this.$message ({
			// 		message:'请选择项目！',
			// 		type:'error'
			// 	})
			// 	return;
			// }
			// if(row.ddIdProjectStatusName !== "复核意见填写"){
			// 	this.$message ({
			// 		message:'无权限！',
			// 		type:'error'
			// 	})
			// 	return;
			// }
			
		},
		downloadFile(file){
			console.log(file,'file')
			
				let resp = {
					fileName:file,
				}
				generateTemporaryUrlByFileName(resp).then(resu=>{
					console.log(resu,'resussss')
					if (typeof resu.data !== 'string'){
						this.$message.error('图纸不存在，请联系网信部工作人员！')
					}else {
						window.open(resu.data)
					}
				})
			
		},
		async getProjectListContract(){
			let params = {
				pageIndex: 1,
				pageSize: 400,
				ddIdNodeBizType:100
			}
			const res = await getDrContractList(params)
			if (res.data.success){
				console.log(res,'resContract')
				this.ddIdContractList = res.data.response.data
			}
		},
		async getNamespaceArr(){
			let params = {
				namespace:"BizSevice.DrProject.VenueNature",
			}
			const res = await getByNamespace(params)
			if (res.data.success){
				this.ddIdVenueNature = res.data.response
			}
		},
		// 预审转正式
		pretrialToFormal () {
			if (this.needData) {
				this.addNewEntryDialogToForm = true
				this.addNewEntryLoading = false
				this.addNewEntryForm = {
					id:this.needData.id,
					isPrequalification:this.needData.isPrequalification,
					projectCompany:this.needData.projectCompany,
					contractId:this.needData.contractId,
					
					
					code: this.needData.contractNo,
					entryName: this.needData.projectName,
					entryType: this.needData.ddIdProjectType,
					endTimer: this.needData.projectGovPeriodDay,
					noEndTimer: !this.needData.isGovPromise,
					areaMeasure: this.needData.projectArea,
					remark: this.needData.projectNotes,
					entryContacts: this.needData.projectContacts,
					entryPhone: this.needData.projectPhone,
					// 20230208新加
					// isAntecedentTrial: JSON.stringify(this.needData.isPrequalification),
					projectType: this.needData.ddIdProjectType,
					engineeringType: this.needData.ddIdEngineeringType,
					settleTimer: this.needData.projectPeriod,
					customReportNo: this.needData.customReportNo,
					customFailReportNo:this.needData.customFailReportNo,
					coefficient:this.needData.coefficient,
					firstReportOverdueNums: this.needData.firstReportOverdueNums,
					reviewReportOverdueNums: this.needData.reviewReportOverdueNums
				}
			} else {
				this.$message.warning("请选择需要修改项！")
			}
		},
		// 提交预审转正式
		addNewEntrySubmit () {
			this.$refs.addNewEntryRef.validate((valid) => {
				if (valid) {
					this.addNewEntryLoading = true;
					const params = {
						contractId: this.addNewEntryForm.contractId,
						customReportNo: this.addNewEntryForm.customReportNo,
						customFailReportNo: this.addNewEntryForm.customFailReportNo,
						coefficient:this.addNewEntryForm.coefficient,
						ddIdEngineeringType: this.addNewEntryForm.engineeringType,
						ddIdProjectType: this.addNewEntryForm.projectType,
						firstReportOverdueNums: parseInt(this.addNewEntryForm.firstReportOverdueNums),
						id: this.addNewEntryForm.id,
						isGovPromise: this.addNewEntryForm.noEndTimer,
						isPrequalification: this.addNewEntryForm.isPrequalification,
						projectArea: this.addNewEntryForm.areaMeasure,
						projectCompany: this.addNewEntryForm.projectCompany,
						projectContacts: this.addNewEntryForm.entryContacts,
						projectGovPeriodDay: this.addNewEntryForm.endTimer,
						projectName: this.addNewEntryForm.entryName,
						// ddIdProjectType: this.addNewEntryForm.entryType,
						
						// isGovPromise: !this.addNewEntryForm.noEndTimer,
						projectNotes: this.addNewEntryForm.remark,
						projectPeriod: this.addNewEntryForm.settleTimer,
						projectPhone: this.addNewEntryForm.entryPhone,
						// 20230208新加
						// isPrequalification: this.addNewEntryForm.isAntecedentTrial,
						reviewReportOverdueNums: parseInt(this.addNewEntryForm.reviewReportOverdueNums),
						
					}
					// console.log(params)
					
					// params.contractId = this.currentContract.id;
					convertFormalProject(params).then(res => {
						this.addNewEntryLoading = false;
						this.addNewEntryDialogToForm = false;
						const result = res.data
						if (result.success) {
							this.$message.success(result.message)
							this.getDataList();
						} else {
							this.$message.warning(result.message)
						}
					})
				}
			})
		},
		// 关闭项目登记
		closeThisDialog () {
			this.projectRegisterDialog = false
		},
		// 消防设计审查申请表查看
		viewsApplicationForm (row) {
			this.needData = row
			this.projectRegisterDialog = true
		},
		callFunction (item) {
			this[item.func].apply(this, item)
		},
		activeChange (val) {
			if (val == '2') {
				this.viewsApplicationWidth = '1200px'
			}
			else if (val == '4'){
				this.viewsApplicationWidth =  '1200px'
			}
			else {
				this.viewsApplicationWidth = '70%'
			}
		},
		// 列表查询接口
		getDataList () {
			var params = {
				pageIndex: this.pages.pageIndex,
				pageSize: this.pages.pageSize,
				searchKey: this.filters.keyWord,
				// provinceCode: '440000,540000',
				multiStatus: this.filters.entyType.join(','),
				// status: this.filters.entyType,
				projectStartArea:undefined,//图审开始面积
				projectEndArea:undefined,//图审结束面积
				excludeTestArea:this.filters.excludeTestArea,
				techExpertUserId:this.filters.techExpertUserId,
				ddKeyGroupRule:this.filters.ddKeyGroupRule,
				isFirstAuditSubmit:this.filters.isFirstAuditSubmit,
				sortOrderMode:2,
				isAudit:0,
				// isForceOpinion:1,//是否有强应条（0：无：1：有）
				ddIdNodeBizType:100,
				contractId:this.filters.contractId,
			}
			this.listLoading = true
			getProjectList(params).then(res => {
				var result = res.data
				if (result.success) {
					let data = result.response.data;
					
					const sortOrder = [45, 46, 52, 53, 35, 10, 0, 55]; // 你的自定义排序顺序
					
					data.sort((a, b) => {
						// 获取 ddIdProjectStatus 的索引值
						const indexA = sortOrder.indexOf(a.ddIdProjectStatus);
						const indexB = sortOrder.indexOf(b.ddIdProjectStatus);
						
						// 如果 ddIdProjectStatus 不在 sortOrder 数组中，返回它原来的顺序
						if (indexA === -1) return 1;
						if (indexB === -1) return -1;
						
						// 根据索引值比较
						return indexA - indexB;
					});
					
					console.log(data,'data22222');
					
					this.tableData = data
					
					this.pages.dataCount = result.response.dataCount
				}
				this.listLoading = false
			})
		},
		// 筛选框清空重新请求数据
		handleClear () {
			this.getDataList()
		},
		// 获取省
		getAreaList () {
			var params = {
				parentId: 1,
			}
			getAreaDictionaryList(params).then(res => {
				if (res.data.success) {
					this.areaArr = res.data.response.reverse()
				}
			})
		},
		// 查询
		getProjectList () {
			this.pages.pageIndex = 1
			this.getDataList()
		},
		// 审结操作
		conclusionProject () {
			if (this.needData) {
				this.$confirm('确定审结？', '提示', {}).then(() => {
					var params = {
						projectId: this.needData.id,
						donclusionStatus: 56
					}
					conclusionProject(params).then(res => {
						var result = res.data
						if (result.success) {
							this.$message.success(result.message)
							this.getProjectList()
						} else {
							this.$message.error(result.message)
						}
					})
				})
			} else {
				this.$message.warning('请选择需要审结项！')
			}
		},
		// 申请援助
		applyAssistance () {
			if (this.needData) {
				this.applyForSendSMSDialog = true
				this.applyForSendSMLoading = false
				this.applyRadio = ''
			} else {
				this.$message.warning('请选择需要申请援助项！')
			}
		},
		// 申请援助提交
		applyForSendSMSubmit () {
			if (!this.applyRadio) {
				this.$message.warning('请先选择申请援助原因！')
				return
			}
			var params = {
				bizId: this.needData.id,
				taskStatus: this.applyRadio
			}
			this.applyForSendSMLoading = true
			applyAssistance(params).then(res => {
				var result = res.data
				if (result.success) {
					this.$message.success(result.message)
					this.getProjectList()
					this.applyForSendSMSDialog = false
				} else {
					this.$message.error(result.message)
				}
				this.applyForSendSMLoading = false
			})
		},
		signature () {
			if (this.needData) {
				this.$confirm('确定重新发起签章？', '提示', {}).then(() => {
					let params = {
						projectId: this.needData.id,
					}
					signatureProject(params).then(res => {
						let result = res.data
						if (result.success) {
							this.$message.success(result.message)
							this.getProjectList()
						} else {
							this.$message.error(result.message)
						}
					})
				})
			} else {
				this.$message.warning('请选择需要签章项！')
			}
		},
		// 查看项目
		viewsEntyTemplate (row) {
			this.needData = row
			this.viewsApplicationDialog = true
		},
		viewsApplicationDetail (row) {
			console.log(row,'jjjjjjjjjjjjjjjjjjjjjjj')
			console.log(this.needData,'jjjjjjjjjjjjjjjjjjjjjjj')
			this.needDataDetailList = row
			this.viewsApplicationDetailDialog = true
		},
		
		// 项目参与人员
		viewsParticipants (row) {
			this.ParticipantsDialog = true,
					this.ParticipantsLoading = true,
					this.ParticipantsDialogName = '项目参与人员' + '（ ' + row.projectName + ' ）'
			this.ParticipantsData = []
			var params = {
				projectId: row.id
			}
			getProjectParticipantsOld(params).then(res => {
				var result = res.data
				if (result) {
					console.log(result.response,'项目参与人员')
					this.ParticipantsData = result.response
				} else {
					this.$message.error('加载失败！')
				}
				this.ParticipantsLoading = false
			})
		},
		// 图审人员初审意见
		primaryExaminations (row) {
			this.examinationsDialog = true
			this.componentProjectId = row.id
			this.isFirst = 1 //代表初审意见
		},
		// 图审人复核审意见
		checkExaminations (row) {
			this.examinationsDialog = true
			this.componentProjectId = row.projectId
			this.isFirst = 2 //代表复审意见
		},
		// 图审人员复核意见
		primaryCheckExaminations (row) {
			this.reportORidea = false
			this.reviewReportDialog = true,
					// this.reviewTableLoading = true,
					this.reviewReportData = []
			this.needData = row
			this.preliminaryProjectId = row.id
			// var params = {
			//     projectId: row.id
			// }
			// getTaskReviewList(params).then(res => {
			//     var result = res.data
			//     if(result) {
			//         this.reviewReportData = result.response
			//     } else {
			//         this.$message.error("加载失败！")
			//     }
			//     this.reviewTableLoading = false
			// })
		},
		// 初审报告
		viewsPreliminaryReport (row) {
			this.preliminaryReportDialog = true
			this.preliminaryReportLoading = false
			this.preliminaryProjectId = row.id
		},
		// 图审报告
		viewsAuditReport (row) {
			this.dialogReportVisible = true
			this.preliminaryProjectId = row.id
		},
		//下载图纸
		downloadDrawings(value){
			let params = {
				isGenerateTemporaryUrL:0,//是否需要生成临时授权地址（0：否 1：是）
				projectNo:value.projectNo,//项目编号
			}
			getCompressedProjectFile(params).then(res => {
				console.log(res.data,'下载图纸压缩文件')
				let resp = {
					fileName:res.data,
				}
				generateTemporaryUrlByFileName(resp).then(resu=>{
					console.log(resu,'resu')
					window.open(resu.data)
				})
			})
		},
		// 初审报告发起签章
		preliminaryReportSubmit () {
		
		},
		// 查看复核报告
		viewsreviewReport(row) {
			this.reportORidea = true
			this.reviewReportDialog = true,
					this.reviewTableLoading = true,
					this.needData = row
			this.preliminaryProjectId = row.id
			// var params = {
			//     projectId: row.id
			// }
			// getProjectReports(params).then(res => {
			//     var result = res.data
			//     if(result) {
			//         this.reviewReportData = result
			//     } else {
			//         this.$message.error("加载失败！")
			//     }
			//     this.reviewTableLoading = false
			// })
		},
		// 复核报告/意见的操作查看功能
		reviewReportClick(row) {
			// 报告
			if(this.reportORidea) {
				// this.viewsPreliminaryReport(this.needData)
				// 下载复核报告
				let a = document.createElement('a');
				a.href = row.finalReportPath?row.finalReportPath:row.originalReportPath
				document.body.append(a);
				a.click();
				a.remove();
			} else {
				// 意见
				this.taskId = row.id;
				this.checkExaminations(row)
			}
		},
		// 留言
		viewsLeaveMessage(row) {
			this.leaveMessageDialog = true,
					this.leaveMessageLoading = false,
					this.needData = row
			this.leaveMessageProjectName = row.projectName
			this.leaveMessageContent = ""
			var params = {
				projectId: row.id
			}
			getProjectMessageByProjectId(params).then(res => {
				var result = res.data
				if(result.success) {
					this.leaveMessageArr = result.response
				}
			})
		},
		// 留言提交
		leaveMessageSubmit() {
			if(!this.leaveMessageContent) {
				this.$message.warning("请输入留言内容！")
				return
			}
			var params = {
				parentId: 0,
				projectId: this.needData.id,
				content: this.leaveMessageContent,
			}
			this.leaveMessageLoading = true
			addProjectMessage(params).then(res => {
				var result = res.data
				if(result.success) {
					this.$message.success(result.message)
					this.leaveMessageDialog = false
				} else {
					this.$message.error(result.message)
				}
				this.leaveMessageLoading = false
			})
		},
		// 回复留言
		replyMessageFun(row) {
			this.textareaStr = "回复" + row.createUserName
			this.replyId = row.id
			this.replyPerMessageDialog = true
			this.replyPerMessageLoading = false
		},
		// 回复留言提交
		replyPerMessageSubmit() {
			if(!this.replyPerMessageContent) {
				this.$message.warning("请输入留言内容！")
				return
			}
			var params = {
				parentId: this.replyId,
				projectId: this.needData.id,
				content: this.replyPerMessageContent,
			}
			this.replyPerMessageLoading = true
			addProjectMessage(params).then(res => {
				var result = res.data
				if(result.success) {
					this.$message.success(result.message)
					this.replyPerMessageDialog = false
					var params = {
						projectId: this.needData.id
					}
					getProjectMessageByProjectId(params).then(res => {
						var result = res.data
						if(result.success) {
							this.leaveMessageArr = result.response
						}
					})
				} else {
					this.$message.error(result.message)
				}
				this.replyPerMessageLoading = false
			})
		},
		// 获取项目审结期限倒计时天数
		getProjectDayFun() {
			var params = {
			
			}
			getProjectConclusionExpire(params).then((res) => {
				var result = res.data
				if(result.response && result.response.length > 0) {
					this.isShowReminder = true
					this.projectList = result.response
				} else {
					this.isShowReminder = false
				}
			})
		},
		// 最小化亮灯提醒
		minimizeReminder() {
			this.isSpecialReminder = false
			this.isShowReminder = true
		},
		// 最大化亮灯提醒
		maxsizeReminder() {
			this.isSpecialReminder = true
			this.isShowReminder = true
		},
		// 点击table某一行
		currentChange(val) {
			if(val)
			{
				this.needData = val
				console.log(val,'val')
			}
		},
		// 分页
		handleCurrentChange(val) {
			this.pages.pageIndex = val;
			this.getDataList();
		},
		handleSizeChange(val){
			this.pages.pageSize = val;
			this.getDataList();
		},
		sendCrowdPageChange(val) {
			this.sendCrowdPage.DataCount = val
		},
		// 时间格式化
		formatCreateTime: function(row, column) {
			return !row || row == ""
					? ""
					: util.formatDate.format(new Date(row), "yyyy-MM-dd hh:mm");
		},
		// 表格数据分页条数累计
		indexMethod(index) {
			var currentPage = this.pages.pageIndex
			var pageSize = this.pages.pageSize
			return (index + 1) + (currentPage - 1) * pageSize
		},
		// 列表样式
		rowClass(){
			return 'padding:8px!important;'
		},
		
		
		// 编辑项目
		handleEdit() {
			if(this.needData) {
				let params = {
					projectId: this.needData.id
				}
				getProjectApplicationByProjectId(params).then(res=>{
					if (res.data.success){
						this.editEntryForm = {
							remark: this.needData.projectNotes,
							customReportNo: this.needData.customReportNo,
							customFailReportNo: this.needData.customFailReportNo,
							address: res.data.response.address,
							contractor: res.data.response.contractor,
							id: res.data.response.id,
						}
						this.addNewEntryDialog = true
						this.addNewEntryLoading = false
					}
				})
				
			} else {
				this.$message.warning("请选择需要修改项！")
			}
		},
		// 编辑项目提交
		editEntrySubmit() {
			this.$refs.addNewEntryRef.validate((valid) => {
				if (valid) {
					this.addNewEntryLoading = true;
					let params = {
						...this.editEntryForm,
					}
					params.projectNotes = this.editEntryForm.remark
					params.id=this.needData.id
							updateProjectInfo(params).then(res => {
								this.addNewEntryLoading = false;
								this.addNewEntryDialog = false;
								let result = res.data
								if(result.success) {
									this.$message.success(result.message)
									this.getDataList();
								} else {
									this.$message.warning(result.message)
								}
							})
				}
				let obj = {
					"id":this.editEntryForm.id,
					"projectId": this.needData.id,
					"address": this.editEntryForm.address,
					"approvalFile": null,
					"contacts": null,
					"contractor": this.editEntryForm.contractor,
					"ddIdCategory": null,
					"decorationArea": null,
					"decorationFloor": null,
					"decorationPositions": [],
					"fireFacilitiess": [],
					"isChangePurpose": false,
					"isDecoration": false,
					"isKeepWarm": false,
					"isSpecialFire": null,
					"isStrengthenFire": null,
					"keepWarmFloor": null,
					"keepWarmMaterial": null,
					"keepWarmPosition": null,
					"licenseFile": null,
					"materialTypes": [],
					"notes": null,
					"originalUse": null,
					"phone": null,
					"specialSituations": [],
					"totalArea": null,
					"totalInvestment": null,
					"useCharacter": null,
					"buildReqs": [
						{
							"buildName": "",
							"structureType": "",
							"useCharacter": "",
							"fireRating": "",
							"overgroundFloors": "",
							"undergroundFloors": "",
							"height": "",
							"length": "",
							"landArea": "",
							"overgroundArea": "",
							"undergroundArea": ""
						}
					],
					"companyReqs": [
						{
							"companyTypeName": "",
							"companyName": "",
							"qualificationLevel": "",
							"corporateCard": "",
							"projectDirectorCard": "",
							"phone": ""
						}
					]
				}
				updateProjectApplication(obj).then(res=>{})
			})
		},
		// 编辑项目系数
		handleEditContact () {
			if (this.needData) {
				this.editProjectContactDialog = true
				this.addNewEntryLoading = false
				this.editContactEntryForm = {
					coefficient: this.needData.coefficient,
				}
			} else {
				this.$message.warning("请输入难度系数！")
			}
		},
		// 编辑项目系数提交
		editContactEntrySubmit () {
			this.$refs.addNewContactEntryRef.validate((valid) => {
				if (valid) {
					this.addNewEntryLoading = true;
					var params = {
						coefficient: this.editContactEntryForm.coefficient,
						id: this.needData.id,
					}
					updateProjectInfo(params).then(res => {
						this.addNewEntryLoading = false;
						this.editProjectContactDialog = false;
						var result = res.data
						if (result.success) {
							this.$message.success(result.message)
							this.getDataList();
						} else {
							this.$message.warning(result.message)
						}
					})
				}
			})
		},
		// 重新审图
		resetDrawingReview(){
			if(this.needData) {
				this.resetDrawingReviewDialog = true
				this.resetDrawingReviewLoading = false
				
				this.resetDrawingReviewForm = {
					projectName: this.needData.projectName,
					overdueDate: "",
					
				}
			} else {
				this.$message.warning("请选择需要修改项！")
			}
		},
		// 项目阶段明细
		viewStageList(row) {
			this.stageDialog = true
			this.stageLoading = true
			this.stageData = []
			// let obj = {
			// 	provinceCode:row.provinceCode,
			// }
			// aiDoLogin(obj).then(res=>{
			// 	console.log(res)
			// 	if (res.data.success){
			// 		const aiToken = res.data.response.token;
			// 		const domain = res.data.response.domain
			// 		// 设置自定义请求头
			// 		const headers = {
			// 			'Content-Type': 'application/json',
			// 			'Authorization': `Bearer ${aiToken}`,// 添加你的授权信息
			// 			'accept':'application/json',
			// 			'X-Tuzhi-User':'qingda',
			// 			'X-Tuzhi-JWT':`Bearer ${aiToken}`,
			// 			'X-Tuzhi-ProjectId':this.needData.id
			// 		};
			// 		console.log(aiToken,'this.aitoken')
			// 		// 创建一个新的axios实例
			// 		const axiosInstance = axios.create();
			// 		// // 要发送的数据
			// 		// const postData = {
			// 		// 	project_id : this.needData.id,
			// 		// };
			// 		// 发送 POST 请求
			// 		axiosInstance.get(domain+`/project/${this.needData.id}/progress`, { headers })
			// 				.then(response => {
			// 					// 请求成功，处理返回的数据
			// 					console.log(response.data,'项目进度数据');
			// 					if (response.data){
			// 						const right = response.data.filter(item=>item.state === 'SUCCESS')
			// 						if (right){
			// 							console.log(parseFloat((right.length/response.data.length).toFixed(2))*100+'%',11111)
			// 							this.parseNum = parseFloat((right.length/response.data.length).toFixed(2))*100+'%'
			// 						}
			//
			// 					}
			//
			// 				})
			// 				.catch(error => {
			// 					// 请求失败，处理错误
			// 					console.error('Error:', error);
			// 				});
			// 	}
			// })
			let params = {
				projectId: row.id
			}
			getStageListByProjectId(params).then(res => {
				var result = res.data
				if(result) {
					this.stageData = result.response;
					// console.log(this.stageData);
				} else {
					this.$message.error("加载失败！")
				}
				this.stageLoading = false
			})
			
		},
		// 查看意见
		checkOpinonView(
				row
		) {
			console.log(row,'rowaaa')
			this.showOpinionDialog = true
			this.showOpinionProjectId =this.needData.id
			let flowNodeId = row.assignUploadNodeId
			if(row.assignOpinionNodeId) flowNodeId += ","+row.assignOpinionNodeId
			if(row.assignOpinionSummaryNodeId) flowNodeId += ","+row.assignOpinionSummaryNodeId
			this.nodeIds = flowNodeId
			this.aiDomainUrl = row.aiDomainUrl+'/project/qingda/'+row.aiTaskId+'/'+this.needData.projectName
			this.showOpinionFlowNodeId = row.assignOpinionNodeId
			this.showGroupRuleType = this.needData.ddKeyGroupRuleType
			
		},
		checkOpinonViewDetail(data){
			// 生成路由完整路径
			const routeData = this.$router.resolve({
				path: '/summaryOpinionsToProject',
				query: {
					data: JSON.stringify(data),
					projectId: data.id,
				}
			});
			// 打开新窗口
			window.open(routeData.href, '_blank');
		},
		// 查看报告
		showReportFile(file) {
			let a = document.createElement('a');
			a.href = file
			a.target = 'blank';
			document.body.append(a);
			a.click();
			a.remove();
		},
		colsedProjectDelay(){
			this.projectDelayDialog = false
			
		},
		handleDelay(val){
			this.needdDataDelay = val
			console.log(val,'valDelay')
		},
		//项目延期
		projectDelay () {
			if (this.needData === null || !this.needData.id) {
				this.$message({
					message: '请选择一条数据',
					type: "error"
				});
				return
			}
			this.projectDelayDialog = true,
					this.ParticipantsLoading = true
			this.ParticipantsData = []
			this.ParticipantsDialogName = '项目参与人员:' + '（ ' + this.needData.projectName + ' ）'
			var params = {
				projectId: this.needData.id,
			}
			getProjectParticipantsOld(params).then(res => {
				var result = res.data
				if (result) {
					this.ParticipantsData = result.response;
				} else {
					this.$message.error("加载失败！")
				}
				this.ParticipantsLoading = false
			})
		},
		//提交项目延期
		addProjectDelay(){
			
			this.addNewEntryLoading = true;
			let params = {
				// overdueDate:this.projectDelayContent,//过期时间
				overdueDate:this.needdDataDelay.overdueDate,//过期时间
				taskId:this.needdDataDelay.taskId,//任务ID
			}
			changeTaskOverdueDate(params).then(res => {
				const result = res.data
				if (result.success) {
					this.$message.success(result.message)
					this.getDataList();
					// this.colsedProjectDelay()
				} else {
					this.$message.warning(result.message)
				}
			})
		},
		
		viewsProjectStageUserInfo(projectId,row) {
			this.ParticipantsDialog = true;
			this.ParticipantsLoading = true;
			this.ParticipantsDialogName =  "项目参与人员";
			this.ParticipantsData = []
			
			
			
			var flowNodeId = row.assignUploadNodeId
			if(row.assignOpinionNodeId) flowNodeId += ","+row.assignOpinionNodeId
			if(row.assignOpinionSummaryNodeId) flowNodeId += ","+row.assignOpinionSummaryNodeId
			
			var params = {
				projectId: projectId,
				nodeIds: flowNodeId
			}
			this.ParticipantsData=[];
			getProjectParticipantsOld(params).then(res => {
				var result = res.data
				if(result) {
					// this.ParticipantsData = result.response.filter(item=> item.participationTypeName !== '见习工程师');
					// 用 map 替换 forEach，获取处理后的新数组（map 有返回值）
					const list = result.response?.map(item => {
						// 深拷贝对象，避免修改原数组（可选，根据需求决定是否浅拷贝）
						const newItem = { ...item };
						if (newItem.participationTypeName === '见习工程师') {
							newItem.participationTypeName = '在线工程师';
						}
						return newItem; // 必须返回处理后的元素，map 才会收集成新数组
					});
					
					console.log(list, 'listtttttttttttttttt');
					
					this.ParticipantsData = [
						{
							participationTypeName: '提交单位',
							name: this.needData.createUserName,
							applyStatusName: undefined,
							signStatus: undefined,
							overdueDate: undefined,
							completeDate: this.needData.createTime.split("T")[0] + ' ' + this.needData.createTime.split("T")[1].split(".")[0],
							phoneNumber: this.needData.createUserPhone,
						},
						...(list || []) // 容错：如果 list 是 undefined（比如 result.response 不存在），则解构空数组
					];
				} else {
					this.$message.error("加载失败！")
				}
				this.ParticipantsLoading = false
			})
		},
		//
		
		// 查看意见
		async	viewProjectFile(project) {



			// this.projectFileDataOpinion = []
			//
			// var params = {
			// 	projectId: project.id,
			// }
			// getProjectFileInfo(params).then(res => {
			// 	let result = res.data
			// 	if(result.success) {
			// 		console.log(result.response.files,'filesDrawing')
			// 		if (result.response.files&&result.response.files.length>0){
			// 			const arrList = []
			// 			arrList.push(result.response.files[result.response.files.length-1])
			// 			this.projectFileDataOpinion = this.removeDuplicatesInTree(arrList,'fileName')
			// 			this.viewOpinionDialog = true
			// 		}
			//
			//
			// 	}
			// })
			
			const user = window.localStorage.getItem('user');
			const userData = user ? JSON.parse(user) : {};
			const isTechExpert = userData.roleNames && userData.roleNames.includes('总工室技术专家');

			if (!(project.ddIdProjectStatus==45||project.ddIdProjectStatus==52||project.isContinueAudit)&&!isTechExpert){
				this.$message.warning({
					message: '只有初审复审阶段可以添加意见',
					type: "error"
				});
				return
			}
			this.projectFileDataOpinion = []
			this.needData = project
			await this.viewAllOpinions()
			let item = {
				projectId: project.id,
			}
			isFinishTaskByProjectId(item).then(res => {
				if (res.data.success){
					if (res.data.response){
						this.projectFileDataOpinion = []

						let params = {
							projectId: project.id,
						}
						getProjectFileInfo(params).then(res => {
							let result = res.data
							if (result.success) {
								console.log(result.response.files, 'filesDrawing')
								if (result.response.files && result.response.files.length > 0) {
									const arrList = []
									arrList.push(result.response.files[result.response.files.length - 1])
									this.projectFileDataOpinion = this.removeDuplicatesInTree(arrList, 'fileName')

									// ====================== Vue2 适配：统计 id 数量 ======================
									const countMap = {}
									console.log(this.opinionList,'opinionList,,,,,,,,,,,,,,,,,,,')
									this.opinionList.forEach(item => {
										const id = item.drProjectFileId
										if (id) {
											countMap[id] = (countMap[id] || 0) + 1
										}
									})

									// console.log(countMap,'countMap,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,')
									// ====================== 递归给第四层节点添加 opinionNums ======================
									const addOpinionNums = (nodeList, level = 1) => {
										// 1. 先遍历当前层的所有节点（不管层级）
										if (!nodeList || nodeList.length === 0) return

										nodeList.forEach(node => {
											// 2. 只有【第4层节点】才赋值 opinionNums
											if (level === 5) {
												this.$set(node, 'opinionNums', countMap[node.id] || 0)
											}

											// 3. 递归处理子节点，层级 +1
											addOpinionNums(node.childFiles || [], level + 1)
										})
									}

									// 执行赋值
									addOpinionNums(this.projectFileDataOpinion)

									// console.log(this.projectFileDataOpinion, 'this.projectFileDataOpinion0000000000000000000')
									// 打开弹窗
									this.viewOpinionDialog = true
								}
							}
						})
					}else {
						this.$message.warning({
							message: '当前用户没有任务！',
							type: "error"
						});
					}

				}else {
					this.$message.warning({
						message: '当前用户没有任务！',
						type: "error"
					});
				}
			})





		},
		
		
		
		
		
		showProjectFile(row,flowNodeId) {
	
			this.projectFileDialog = true
			this.projectFileLoading = true
			this.projectFileData = []
			this.lastUploadFlowNodeId = flowNodeId
			// var params = {
			// 	projectId: row.id,
			// 	flowNodeId: flowNodeId
			// }
			// getProjectFileInfoByFlowNodeId(params).then(res => {
			// 	let result = res.data
			// 	if(result.success) {
			// 		console.log(result.response.files,'filesDrawing')
			// 		this.projectFileData = this.removeDuplicatesInTree(result.response.files,'fileName')
			// 		console.log(this.projectFileData,'this.projectFileDataOpinion')
			// 		this.projectFileLoading = false
			// 	}
			// })
			
		},
		
	removeDuplicatesInTree(tree, propName) {
  function processNode(node, depth = 1) {
    // 只有第4层及以上才做处理
    if (depth >= 4 && node.childFiles && node.childFiles.length > 0) {
      const seenThisLevel = new Set(); // 本层去重用的Set
      const validChildren = [];

      for (let child of node.childFiles) {
        const value = child[propName];

        // 跳过带“(转)”或重复的节点
        if (value && String(value).includes('(转)')) continue;
        if (seenThisLevel.has(value)) continue;

        seenThisLevel.add(value);
        // 递归处理子节点（如果有的话）
        const processedChild = processNode(child, depth + 1);
        validChildren.push(processedChild);
      }

      node.childFiles = validChildren;
    } else {
      // 如果不是第4层及以上，或者没有子节点，继续递归处理子节点即可
      if (node.childFiles && node.childFiles.length > 0) {
        node.childFiles = node.childFiles.map(child => processNode(child, depth + 1));
      }
    }

    return node;
  }

  // 从根节点开始，初始深度为1
  return tree.map(node => processNode(node, 1));
}

		,
		changeFreezeStatus(){
			if(this.needData) {
				this.freezeStatusDialog = true
				this.freezeStatusLoading = false
				
				this.freezeStatusForm.freezeStatus = this.needData.ddIdConclusionStatus == 0 ? 57 : 0
			} else {
				this.$message.warning("请选择需要修改项！")
			}
		},
		freezeStatusSubmit(){
			this.$refs.freezeStatusRef.validate((valid) => {
				if (valid) {
					this.freezeStatuswLoading = true;
					var params = {
						id: this.needData.id,
						ddIdConclusionStatus:this.freezeStatusForm.freezeStatus,
					}
					updateProjectInfo(params).then(res => {
						this.freezeStatusLoading = false;
						this.freezeStatusDialog = false;
						var result = res.data
						if(result.success) {
							this.$message.success(result.message)
							this.getDataList();
						} else {
							this.$message.warning(result.message)
						}
					})
				}
			})
		},
		// 修改技术部专家
		changeTechExpert(){
			if(this.needData) {
				this.techExpertDialog = true
				this.techExpertLoading = false
				this.techExpertForm.assignedUserId = undefined;
			} else {
				this.$message.warning("请选择需要修改项！")
			}
		},
		techExpertSubmit(){
			this.$refs.techExpertRef.validate((valid) => {
				if (valid) {
					if(this.techExpertForm.assignedUserId == undefined)
					{
						this.$message.warning("请选择技术专家！")
						return;
					}
					this.techExpertLoading = true;
					var params = {
						projectId: this.needData.id,
						assignedUserId:this.techExpertForm.assignedUserId,
					}
					changeAssignedUserIdByTechExpert(params).then(res => {
						this.techExpertLoading = false;
						this.techExpertDialog = false;
						this.techExpertForm.assignedUserId = undefined;
						var result = res.data
						if(result.success) {
							this.$message.success(result.message)
							this.getDataList();
						} else {
							this.$message.warning(result.message)
						}
					})
				}
			})
		},
		resetDrawingReviewSubmit(){
			this.$refs.resetDrawingReviewRef.validate((valid) => {
				if (valid) {
					this.resetDrawingReviewLoading = true;
					var params = {
						projectId: this.needData.id,
						overdueDate:this.resetDrawingReviewForm.overdueDate,
					}
					resetDrawingReviewApi(params).then(res => {
						this.resetDrawingReviewLoading = false;
						this.resetDrawingReviewDialog = false;
						var result = res.data
						if(result.success) {
							this.$message.success(result.message)
							this.getDataList();
						} else {
							this.$message.warning(result.message)
						}
					})
				}
			})
		}
	},
	computed:{
		
		headers(){
			return {
				"Authorization": 'Bearer ' + localStorage.getItem("Token")
			}
		}
		
	},
	watch: {
			'viewsApplicationDialog': function(newValue, oldValue) {
				if(newValue === false) {
					this.getDataList()
				}
			},
	},
	created(){
		this.utils = util
		let routers = window.localStorage.router
				? JSON.parse(window.localStorage.router)
				: [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.questionUploadFile = uploadFile
		this.answeringUploadFile = uploadFile
		this.getProjectListContract()
		this.getDataList();
		this.getAreaList();
		this.getNamespaceArr()
		this.getProjectDayFun();
	}
}
</script>

<style lang="stylus" scoped>

.opinion-list {
	display: flex;
	flex-direction: column;
	gap: 12px; /* 多条意见之间的间距 */
}
.opinion-item {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	padding: 16px;
	border: 1px solid #ebeef5;
	border-radius: 4px;
	background: #fff;
}

.opinion-content {
	flex: 1;
	font-size: 14px;
	line-height: 1.6;
}
.position-text {
	margin-top: 8px;
	color: #909399;
	font-size: 13px;
}
.opinion-actions {
	display: flex;
	gap: 8px;
}


.toolbar-container {
	display: flex; /* 使用Flex布局 */
	justify-content: space-between; /* 控制内部元素在水平方向上的分布，将它们分散排列 */
	align-items: center; /* 控制内部元素在垂直方向上的对齐方式，可以根据需要调整 */
}
.projectName {
	text-align: center;
}
.projectSelect {
	margin-bottom: 15px;
}
.projectTitle {
	margin-bottom: 15px
}
.replyBtn {
	margin: 10px 0;
	color: #409eff;
	cursor: pointer;
	width: 30px;
}
.replyMessage {
	background: #eee;
	line-height: 30px;
	padding: 5px;
	border-radius: 2px;
	margin: 5px 15px;
}
.titleTimer {
	margin-left: 10px;
}
.specialReminder {
	width: 350px;
	height: 200px;
	background: #fff;
	border-radius: 5px;
	position: fixed;
	right: 7px;
	bottom: 7px;
	z-index: 10;
	border: 1px solid #999;
	overflow: hidden;
}
.reminderBtn {
	display: flex;
	justify-content: flex-end;
	margin-right: 10px;
}
.projectPra {

}
.projectBox {
	width: 90%;
	margin: 0 auto 0;
	height: 150px;
	// display: flex;
	// flex-direction: column;
	// justify-content: center;
	overflow-y: auto;
}
.projectName {
	color: red;
	font-size: 14px;
}
.projectDay {
	color: red;
	font-size: 16px;
	margin-left: 10px;
}
.projectList {
	margin-top: 10px;
	font-size: 14px;
}
.miniBox {
	width: 45px;
	height: 45px;
	position: fixed;
	right: 7px;
	bottom: 7px;
	border-radius: 5px 5px 0 0;
	border-left: 2px solid #999;
	border-top: 2px solid #999;
	border-right: 2px solid #999;
	z-index: 10;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.miniNodes {
	width: 25px;
	height: 25px;
	right: 7px;
	bottom: 7px;
	border-radius: 5px;
	border: 2px solid #999;
	z-index: 10;
}
.viewProject>>>.el-dialog__body {
	padding: 0px 20px 30px;
	margin-top: -15px;
}
</style>
